export const ja = {
  nav: {
    privileges: "特典",
    memberships: "メンバーシップ",
    faqs: "よくある質問",
    guides: "ガイド",
    news: "ニュース",
    about: "私たちについて",
    contact: "お問い合わせ",
    applyOnline: "オンライン申請",
    eliteVisa: "タイランドエリートビザ",
    privilegePoints: "プリビレッジポイント",
    howToApply: "申請方法",
    bronze: "ブロンズ – 5年",
    gold: "ゴールド – 5年",
    platinum: "プラチナ – 10年",
    diamond: "ダイヤモンド – 15年",
    reserve: "リザーブ – 20年",
    family: "ファミリービザ",
    compare: "比較",
    blog: "記事",
    downloads: "ダウンロード",
  },
  meta: {
    homeTitle: "タイランドエリート – 公式GSSA | タイ長期ビザ",
    homeDescription: "タイランドエリート（タイランドプリビレッジ）公式GSSA。5〜20年マルチエントリービザ、VIP空港サービス、コンシェルジュ、特典付き。今すぐオンライン申請。",
  },
  hero: {
    badge: "2015年以来認定グローバルセールス＆サービスエージェント",
    tabs: {
      overview:    "概要",
      advantages:  "メリット",
      eligibility: "資格",
      membership:  "会員資格",
    },
    title: "タイランドエリートビザ",
    titleSub: "5〜20年の特権メンバーシップ",
    subtitle: "長期滞在ビザ＆特典",
    description: "シンプル＆安全 — 承認後にのみお支払い。1ヶ月以内にタイランドエリートメンバーになれます。",
    cta: "今すぐオンライン申請",
    secure: "安全",
    support: "24時間年中無休のグローバルサポート",
    noFees: "隠れた費用なし",
    payAfter: "承認後の支払い",
  },
  homeFaqs: {
    badge: "よくある質問",
    title: "タイランドエリートビザ — よくある質問",
    intro: "タイランドエリート会員、Thailand Privilege Visa、資格要件、公式申請プロセスについて最も多い質問への素早い回答。",
    seeAll: "36件すべての質問を見る",
  },
  homeGuides: {
    badge: "会員ガイド",
    title: "タイランドエリートで暮らすタイ",
    intro: "タイでの暮らしに必要なすべて——長期ビザと会員特典から、銀行口座開設、運転免許の取得、そして 24 時間体制の会員サポートまで。",
    browseAll: "12件すべての会員ガイドを見る",
    featured: {
      longStayVisa: {
        title: "長期マルチエントリービザ",
        desc: "5〜20 年の合法的滞在と無制限の出入国、到着時の優先入国審査——ビザランや 90 日ビザの心配は不要です。",
        cta: "ビザを見る",
      },
      privileges: {
        title: "タイ生活のための特典",
        desc: "年次健康診断、ホテルとライフスタイルの限定プロモーション、ゴルフとスパ特典、政府機関コンシェルジュ——長期居住者の日常に寄り添う特典の数々。",
        cta: "特典を見る",
      },
    },
    memberService: {
      title: "24 時間会員サービス",
      desc: "コンシェルジュ、入国管理サポート、予約手配、翻訳——メンバーコンタクトセンターがタイでの毎日を 24 時間サポートします。",
    },
  },
  atAGlance: {
    badge: "主要データ",
    title: "タイランドエリートの概要",
    definition:
      "タイランドエリート（Thailand Privilege Visa）は、タイ政府観光庁傘下の国営機関である Thailand Privilege Card が運営する長期滞在ビザプログラムです。会員は5〜20年のマルチエントリービザに加え、VIP空港サービス、コンシェルジュ、ライフスタイル特典を受けられます。",
    facts: [
      { label: "開始年",   value: "2003年7月",                                desc: "アジア初の投資による居住プログラム。" },
      { label: "会員",     value: "50か国以上から40,000人以上",                desc: "駐在員、リタイア層、リモートワーカーから成る世界的なコミュニティ。" },
      { label: "認定",     value: "認定 GSSA — ライセンス SA21/012",          desc: "Dreamond はプログラムの完全認定 Global Sales & Services Agent。" },
      { label: "ビザ期間", value: "5〜20年",                                  desc: "タイで外国人が取得できる最長のマルチエントリービザ。" },
      { label: "価格帯",   value: "650,000 – 5,000,000 バーツ",              desc: "一回限りの会員費 — 年間更新料なし。" },
      { label: "プラン",   value: "Bronze · Gold · Platinum · Diamond · Reserve", desc: "エントリーの Bronze から20年・招待制の Reserve まで。" },
    ],
  },
  overview: {
    badge: "政府所有プログラム",
    title: "タイランドエリート",
    subtitle: "タイでの特権的長期滞在",
    description: "タイランドエリートは、アジア初の特権付き長期滞在ビザプログラムです。50カ国以上から40,000人以上の会員を擁し、タイで暮らし・旅するためのVIPパスです。",
    card1Title: "タイへのエリートパス",
    card1Desc: "メンバーには5年間更新可能なマルチエントリービザが付与されます。タイで最も長いビザです。",
    card2Title: "認定＆手続き支援",
    card2Desc: "タイでの生活をより簡単に。政府機関での支援と特典の世界へのアクセス。",
    card3Title: "特典",
    card3Desc: "コンシェルジュサービス、空港ファストトラック、リムジンサービス、ホテル・スパ・ゴルフ場での限定割引。",
  },
  advantages: {
    badge: "タイでVIPになる",
    title: "メリット",
    description: "タイランドエリートメンバーになると、5年間のマルチエントリービザ、タイの銀行口座、運転免許証、24時間コンシェルジュ、空港ファストトラック、リムジンサービスなどの限定特典が利用できます。",
    visa: "5年間マルチエントリービザ",
    visaDesc: "利用可能な最長ビザでタイに全期間または一部期間滞在。",
    banking: "タイの銀行口座",
    bankingDesc: "完全なインターネットバンキングアクセス付きの複数通貨口座を開設。",
    concierge: "24時間コンシェルジュ",
    conciergeDesc: "すべてのニーズに対応するパーソナルアシスタンス。",
    airport: "空港ファストトラック",
    airportDesc: "主要空港でのVIP入国審査処理で行列をスキップ。",
    limousine: "リムジンサービス",
    limousineDesc: "高級車による無料空港送迎。",
    lifestyle: "ライフスタイル特典",
    lifestyleDesc: "プレミアムホテル、スパ、ゴルフ場、レストランでの限定割引。",
  },
  eligibility: {
    title: "資格要件",
    subtitle: "タイランドエリートの要件",
    items: [
      "タイでのビザ超過滞在記録なし",
      "受理された国の外国パスポートを保持",
      "精神的に健全で能力があると認められていること",
      "いかなる国でも禁固刑を受けていないこと（過失を除く）",
      "申請は入国管理局の承認が必要",
      "選択したプログラムの会費の支払い",
    ],
  },
  memberships: {
    intro: {
      title: "プレミアム特典付き長期滞在ビザ",
      body1:
        "Thailand Privilege Card（国際的には Thailand Elite として知られています）は、タイ王国で唯一、政府公認の長期滞在プログラムです。すべての会員には、会員期間全体で有効なマルチエントリーのプリビレッジ・エントリー・ビザが付与されます。Bronze と Gold は5年、Reserve は最長20年で、各入国ごとに1年間の滞在が認められ、タイ国内で出国することなく更新できます。",
      body2:
        "ビザに加え、会員はタイでの生活を快適にするために厳選されたサービスをご利用いただけます：空港でのイミグレーション・ファストトラックと VIP グリーター、無料のリムジン送迎、24時間多言語対応のコンシェルジュ、政府・行政手続きのサポート、銀行口座開設のアシスタンス、年次健康診断、そして全国のゴルフ、スパ、レストラン、ホスピタリティパートナーでの限定ライフスタイル特典。",
      body3:
        "頻繁に旅行される方、リタイア後の方、リモートワークのプロフェッショナル、タイへの移住をお考えのご家族にとって、Thailand Elite は卓越した価値を提供します — 繰り返しのビザラン、複雑な延長手続き、数多くのコンシェルジュおよびイミグレーション・サービスを、一つの予測可能なメンバーシップに置き換えます。",
    },
    comparison: {
      title: "5つの会員プランを比較",
      intro: "現行のタイランドエリート全5プランを並べて比較：価格、ビザ期間、ファミリーオプション、年間特典ポイント。",
      headers: {
        tier: "プラン",
        duration: "期間",
        price: "価格",
        family: "ファミリーオプション",
        points: "特典ポイント",
      },
      viewFullCta: "機能ごとの詳細比較を見る",
    },
    badge: "メンバーシッププログラム",
    title: "Thailand Privilege メンバーシップ",
    subtitle: "タイランドエリートメンバーシップティアを発見",
    learnMore: "詳細を見る",
    perYear: "年間",
    years: "年",
    tiers: {
      bronze: { name: "ブロンズ", duration: "5年", price: "THB 650,000", description: "マルチエントリービザと厳選された特典付きの5年間メンバーシップ。お申し込みは2026年12月31日まで。" },
      gold: { name: "ゴールド", duration: "5年", price: "THB 900,000", description: "プレミアム特典付きの5年間メンバーシップ。" },
      platinum: { name: "プラチナ", duration: "10年", price: "THB 1,500,000", description: "全期間のビザと限定特典付きの10年間メンバーシップ。家族メンバーは2026年12月31日まで1人75万バーツ。" },
      diamond: { name: "ダイヤモンド", duration: "15年", price: "THB 2,500,000", description: "比類なき特典付きの15年間メンバーシップ。家族メンバーは2026年12月31日まで1人75万バーツ。" },
      reserve: { name: "リザーブ", duration: "20年", price: "THB 5,000,000", description: "招待制のみの限定20年間メンバーシップ — タイランドエリートの頂点。" },
    },
  },
  discontinuedMemberships: {
    metaTitle: "終了したThailand Eliteメンバーシップ | 2023年終了の旧プログラム",
    metaDescription: "終了したThailand Elite旧プログラムの会員向け情報。現在のメンバーシップ、アップグレードの可能性、更新や延長の相談先を確認できます。",
    badge: "旧メンバーシップ",
    title: "終了したThailand Eliteメンバーシップ",
    subtitle: "これらの旧Thailand Eliteプログラムは2023年に終了しました。すでにこれらのいずれかの会員である場合、現在のステータスや有効期限に応じて、アップグレード、延長、更新の選択肢が残っている可能性があります。",
    programsTitle: "このページで扱う旧プログラム",
    programsIntro: "以下の旧プログラムのいずれかでThailand Eliteに加入した方は、このページで次に取るべき現実的な選択肢を確認できます。",
    rightsTitle: "現在の権利と特典について",
    rightsBody: "これらの旧プログラムのいずれかの会員である場合、通常はウェルカムレター、会員規約、公式プログラム文書に記載された内容に従い、会員期限が終了するまで、その会員に付随するサービスと特典を引き続き利用できます。\n\n正確な権利内容については、必ずご自身の元の会員書類と、該当プログラムに適用される公式条件をご確認ください。",
    upgradeTitle: "アップグレードと更新の選択肢",
    upgradeBody: "これらの旧メンバーシップは新規申請では利用できません。既存会員は、現在の会員種別や有効期限に応じて、現行のThailand Privilegeパッケージへ移行する必要がある場合があります。\n\n一部のメンバーシップでは、特定のアップグレード経路が引き続き利用できる可能性があります。たとえば、Elite Easy Access会員は、現在の会員期限の6か月前までであれば、Elite Superiority Extension（20年）へアップグレードできる場合があります。",
    contactTitle: "すでに会員の方へ",
    contactBody: "すでにThailand Elite会員で、更新、延長、アップグレードの選択肢を確認したい場合は、当社チームへご連絡いただくか、ライブチャットをご利用ください。現在の状況を確認し、最も適した次のステップをご案内します。",
    actionsTitle: "推奨される次のステップ",
    actionsIntro: "まず現在のメンバーシップパッケージをご確認ください。そのうえで、既存会員として利用できる選択肢の整理が必要であれば当社へご相談ください。",
    viewMemberships: "現在のメンバーシップを見る",
    contactUs: "チームに連絡する",
    note: "重要: 利用可能なアップグレードや更新の可否は、現在の会員種別、ステータス、有効期限までの残り期間によって異なります。最終的な適格性は、申請時点で有効な公式ルールに従います。",
  },
  steps: {
    title: "3ステップでタイランドエリートメンバーに",
    subtitle: "透明で簡潔。申請からメンバーシップまで4〜12週間。",
    step1Title: "申請",
    step1Desc: "選択したメンバーシップのタイランドエリート申請を提出。",
    step2Title: "承認",
    step2Desc: "入国管理局の承認を待ち（4〜12週間）、その後お支払い。",
    step3Title: "メンバー",
    step3Desc: "お支払い確認後、正式にタイランドエリートメンバーになります。",
    ctaButton: "Thailand Privilege に申し込む",
  },
  cta: {
    title: "40,000人以上のタイランドエリートメンバーに加わる",
    description: "タイ唯一の居住プログラムに参加して、特典とVIPサービスの世界にアクセス。",
    button: "今日申請する",
  },
  footer: {
    usefulLinks: "便利なリンク",
    contact: "お問い合わせ",
    social: "ソーシャル",
    ratings: "全プラットフォームで4.8/5の評価",
    authorized: "2015年以来認定GSSAエージェント",
    copyright: "Copyright 2026 Thailand Elite GSSA. 全著作権所有。Powered by Dreamond",
    gssaAttribution: "タイランドエリート長期滞在ビザプログラムの認定 Global Sales & Services Agent (GSSA) — Dreamond、ライセンス SA21/012。",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    requestInfo: "詳細情報を請求",
    applyOnline: "24時間オンライン申請",
  },
  trust: {
    noExtra: "追加料金なし",
    experience: "25年以上の経験",
    support: "24時間多言語サポート",
    licensed: "完全認可プロバイダー",
    secure: "100%安全な処理",
  },
  notFound: {
    title: "ページが見つかりません",
    subtitle: "お探しのページは存在しないか、移動されました。",
    backHome: "ホームページに戻る",
    home: "ホームページ",
    homeDesc: "メインページに戻る",
    memberships: "メンバーシップ",
    membershipsDesc: "メンバーシップティアを探索",
    faqs: "よくある質問",
    faqsDesc: "よくある質問の回答を見つける",
    contact: "お問い合わせ",
    contactDesc: "チームに連絡する",
  },
  about: {
    metaTitle: "タイランドエリートGSSAについて – 2015年以来認定エージェント",
    metaDescription: "40,000人以上のメンバーがタイのプレミア居住プログラムにアクセスするのを支援する認定グローバルセールス＆サービスエージェント、タイランドエリートGSSAについて。",
    badge: "私たちについて",
    title: "信頼できるタイランドエリートパートナー",
    subtitle: "2015年以来の認定GSSAエージェントとして、世界中の申請者のためにタイランドエリートメンバーシッププロセスを簡素化しています。",
    whatIsTitle: "タイランドエリートとは？",
    whatIsP1: "タイランドエリートは、尊敬される外国人ゲストにタイの最高のバケーションと長期滞在体験を提供するという目標から生まれました。2003年7月、アジア初の投資による長期居住プログラムとなりました。",
    whatIsP2: "タイランドエリートは、タイ観光庁（TAT）の完全子会社であるタイランド・プリビレッジ・カード・カンパニー・リミテッドが運営しています。50カ国以上から40,000人以上の会員を擁し、アジアをリードする居住プログラムです。",
    objectivesTitle: "タイランドエリートの目標",
    objectives: {
      attract: { title: "著名なゲストを誘致", desc: "裕福なゲスト、ビジネスマン、起業家、投資家、長期滞在グループを誘致することを目標としています。" },
      privileges: { title: "一流＆限定特典", desc: "入国管理・空港サービスや幅広いレジャー・ビジネス特典により、世界最高の居住プログラムです。" },
      treatment: { title: "特別な待遇", desc: "ゴルフ場、スパ、ホテル、レストラン、病院がワールドクラスのサービスでお迎えします。" },
      friend: { title: "タイの大切な友人", desc: "タイのホスピタリティの象徴である温かい歓迎と笑顔でお迎えします。" },
    },
    visionTitle: "ビジョン",
    visionText: "タイの友人のために作られた特別な居住プログラムのアジアにおけるリーディングプロバイダー。",
    missionTitle: "ミッション",
    missionItems: ["タイランド・プリビレッジ・エントリー・ビザ（PE）の提供", "メンバーの期待を超える最高の特典とサービスの提供", "タイの高級観光の促進", "タイ経済の成長を促進するための公共・民間セクターの支援"],
    coreValuesTitle: "コアバリュー",
    coreValuesText: "倫理、透明性、コミットメント、対応力。私たちの目標は、尊敬されるタイランドエリートメンバーに質の高いプロフェッショナルなサービスを提供することです。",
    storyTitle: "私たちについて",
    storyP1: "2015年以来、タイランド・プリビレッジ・カード・カンパニー・リミテッドの公認グローバルセールス＆サービスエージェント（GSSA）です。",
    storyP2: "タイでの長期居住を希望する方々にシームレスで透明性のある安全な申請体験を提供することが私たちのミッションです。",
    storyP3: "50カ国以上のクライアントにサービスを提供する多言語チームで、深いローカル専門知識とグローバルな視点を組み合わせています。",
    valuesTitle: "私たちの価値観",
    valuesSubtitle: "私たちの行動の指針となる原則。",
    values: {
      trust: { title: "信頼＆透明性", desc: "隠れた費用なし、サプライズなし。あらゆる段階で完全な透明性。" },
      excellence: { title: "卓越性", desc: "すべてのクライアントとのやり取りで最高水準のサービスを追求。" },
      service: { title: "パーソナルサービス", desc: "申請からメンバーシップまで、そしてそれ以降も専任サポート。" },
      global: { title: "グローバルリーチ", desc: "50カ国以上で多言語サポートを提供。" },
      government: { title: "政府支援", desc: "公式認可が正当性と信頼性を保証。" },
      exclusive: { title: "限定アクセス", desc: "すべてのメンバーに優先対応とVIP待遇。" },
    },
    stats: {
      members: { value: "40,000+", label: "世界中のメンバー" },
      countries: { value: "50+", label: "対応国数" },
      yearsExp: { value: "10+", label: "年の経験" },
      satisfaction: { value: "4.8/5", label: "顧客満足度" },
    },
    whoTitle: "パートナー＆認定",
    whoDesc: "タイランドエリートメンバーシッププログラムは、タイ観光庁（TAT）が完全所有するタイランド・プリビレッジ・カード・カンパニー・リミテッドが運営しています。プロモーションと申請サポートはDreamondが提供しています（認定GSSA、登録番号SA21/012）。",
    tpcLearnMore: "→ タイランドプリビレッジカードプログラムの詳細",
    tpcGuideLink: "→ タイランドプリビレッジカード完全ガイド",
    tpcCardLink: "→ タイランドプリビレッジカード — 会員、特典、申し込み方法",
    dreamondTitle: "Dreamond — 認定GSSAエージェント",
    dreamondDesc: "国家機関認定のグローバルセールス＆サービスエージェント（GSSA）として、タイランド・プリビレッジ・カード/タイランドエリートプログラムのプロフェッショナルなコンサルテーションとサポートを提供しています。",
    dreamondFeatures: ["追加料金なし — 政府機関への承認後にのみ支払い", "25年以上の経験を持つプロフェッショナルチーム", "複数言語での24時間ワールドクラスサポート", "完全認可・規制されたサービスプロバイダー", "100%安全で機密性の高い処理"],
    officialSources: {
      title: "政府機関",
      intro: "タイランドエリートはタイ王国の公式長期滞在ビザプログラムです。観光政策の監督や入国管理規則については、以下のタイ政府機関をご参照ください。",
      tat: "タイ国政府観光庁 (TAT)",
      immigration: "タイ王国入国管理局",
    },
  },
  contact: {
    metaTitle: "タイランドエリートGSSAへのお問い合わせ",
    metaDescription: "タイランドエリートメンバーシップに関するお問い合わせ、申請サポートなど。バンコクの認定GSSAエージェント。",
    title: "お問い合わせ",
    subtitle: "タイランドエリートメンバーシップに関するご質問や資料のご請求は、お気軽にお問い合わせください。",
    infoTitle: "お問い合わせ",
    infoSubtitle: "タイランドエリートメンバーシップに関するご質問や資料のご請求は、お気軽にお問い合わせください。",
    disclaimer: "タイランドエリートに関するご質問とサポートのみお受けしています。",
    disclaimerSub: "私たちは大使館ではなく、観光ビザの発行も行っておりません。",
    memberNote: "すでにタイランドエリートメンバーの方は、",
    memberNoteDetail: "メンバーサービス（ウェルカムメール参照）またはエージェントにお問い合わせください。",
    email: "メール",
    address: "本社",
    addressValue: "バンコク、タイ – 予約制。",
    hours: "営業時間",
    hoursValue: "月曜〜金曜、9:00〜18:00（ICT）",
    usefulLinks: "便利なリンク",
    linkFaqs: "よくある質問",
    linkApply: "オンライン申請ポータル",
    linkMemberships: "メンバーシッププログラム",
    linkHowToApply: "申請プロセス",
    worldwide: "世界中にエージェント代理店があります。",
    formTitle: "メッセージを送る",
    formSubtitle: "フォームにご記入ください。チームが迅速に対応いたします。",
    firstName: "名",
    lastName: "姓",
    emailLabel: "メール",
    phoneLabel: "電話番号",
    subject: "件名",
    selectSubject: "件名を選択...",
    subjectMembership: "メンバーシップ情報",
    subjectPricing: "価格＆費用",
    subjectApplication: "申請プロセス",
    subjectRenewal: "更新＆延長",
    subjectOther: "その他",
    message: "メッセージ",
    messagePlaceholder: "ご要望をお聞かせください...",
    send: "メッセージを送信",
      sendAnother: "別のメッセージを送る",
    successTitle: "メッセージ送信完了",
    successMsg: "メッセージが送信されました。確認メールをご確認ください。担当者より折り返しご連絡いたします。",
  },
  faqs: {
    metaTitle: "タイランドエリートFAQ – よくある質問",
    metaDescription: "タイランドエリートメンバーシップ、ビザ、費用、申請プロセスなどに関するよくある質問への回答。",
    title: "よくある質問",
    subtitle: "タイランドエリートメンバーシップについて知っておくべきすべてのこと。",
    searchPlaceholder: "よくある質問を検索...",
    resultsFound: "件の結果",
    noResults: "結果が見つかりません。別の検索語をお試しください。",
    categories: {
      application: "申請プロセス",
      visa: "ビザ＆入国",
      payment: "支払い＆費用",
      membership: "メンバーシップ＆労働",
      services: "メンバーサービス",
      reporting: "届出＆コンプライアンス",
    },
    items: {
      appProcess: { q: "申請プロセスはどのくらいかかりますか？", a: "全体のプロセスは1〜3ヶ月かかる場合があります。チームが提出を処理し、各ステップで情報を提供します。支払いは入国管理局の承認後にのみ必要です。" },
      requiredDocs: { q: "必要な書類は何ですか？", a: "パスポート識別ページのコピー（1年以上の有効期限）、カラーID写真、選択したメンバーシップの申請書、家族申請の場合は家族関係の証明が必要です。" },
      applyRemotely: { q: "リモートで申請できますか？", a: "はい、リモートで申請できます。全プロセスはオンラインポータルまたはメールで行えます。" },
      applyFamily: { q: "家族と一緒に申請できますか？", a: "プラチナ10年およびダイヤモンド15年メンバーシップで直系家族と申請できます。現在、家族プロモーション割引があります。" },
      eligibility: { q: "どの国籍が対象ですか？", a: "すべての国の市民（北朝鮮を除く）が申請できます。" },
      edVisa: { q: "教育ビザの履歴がある場合、申請できますか？", a: "はい、ただし却下のリスクが高くなる可能性があります。" },
      overstay: { q: "超過滞在中でも申請できますか？", a: "いいえ、現在超過滞在中の方は資格がありません。まず出国する必要があります。" },
      whatIsVisa: { q: "タイランドエリートビザとは？", a: "タイランドエリートビザは「プリビレッジ・エントリー・ビザ」（PE）— 入国ごとに1年間延長可能な特別な5年間更新マルチエントリービザです。" },
      visaDuration: { q: "出国せずに1年以上タイに滞在できますか？", a: "入国スタンプでデフォルトで1年間の滞在が許可されます。滞在延長は期限前に入国管理局で申請できます。" },
      passportValidity: { q: "パスポートの有効期限が5年未満の場合はどうなりますか？", a: "ビザはパスポートの有効期限に合わせて発行されます。残りの有効期間は新しいパスポートに移行されます。" },
      visaLessThan5: { q: "なぜ5年未満のエリートビザを受け取ったのですか？", a: "パスポートの有効期限が5年未満の場合に発生します。" },
      stayExtension: { q: "年間滞在延長はどのように機能しますか？", a: "5年間のビザ有効期間にもかかわらず、各滞在は1年間に制限されます。タイランドエリートが公式レターと支援を提供します。" },
      ninetyDay: { q: "90日届出の要件は何ですか？", a: "タイに90日以上連続滞在するすべての外国人は、90日ごとに住所を届け出る必要があります。タイランドエリートが無料の届出サービスを提供しています。" },
      visaAffix: { q: "タイランドエリートビザはどこで取得できますか？", a: "スワンナプーム空港、プーケット空港、チェーンワッタナ入国管理局、またはタイ王国領事館で取得できます。" },
      howToPay: { q: "支払いはどのように行いますか？", a: "承認後、公式承認書と請求書が届きます。30日以内にお支払いください。" },
      isSafe: { q: "支払いは安全ですか？", a: "はい。支払いは入国管理局の承認後にのみ要求されます。" },
      paymentMethods: { q: "利用可能な支払い方法は？", a: "銀行振込、クレジットカード（Visa、Mastercard、UnionPay）、Alipay、PromptPay、クルンタイ銀行での現金送金。" },
      workPermit: { q: "タイランドエリートビザでタイで働けますか？", a: "PEビザは観光ビザに分類され、労働許可証の申請はできません。" },
      touristVisa: { q: "観光ビザを持っていても申請できますか？", a: "はい、観光ビザ、到着ビザ、ビザ免除で申請できます。" },
      nonBVisa: { q: "ノンイミグラント（B）ビザで申請できますか？", a: "はい、ただしPEビザ有効化前にノンイミグラントビザをキャンセルする必要があります。" },
      nonOVisa: { q: "Non-OまたはNon-OAビザで申請できますか？", a: "はい、ただしエリートビザ貼付前にノンイミグラントビザをキャンセルする必要があります。" },
      cancel: { q: "メンバーシップをキャンセルできますか？", a: "一定の条件下でキャンセル可能で、残存期間に応じて部分的な返金があります。" },
      whatIsTPC: { q: "タイランド・プリビレッジ・カードとは？", a: "タイランド・プリビレッジ・カード・カンパニー・リミテッドは、タイランドエリートプログラムを運営する国営企業です。" },
      bankAccount: { q: "タイランドエリートメンバーは銀行口座を開設できますか？", a: "はい。主要銀行でタイバーツ貯蓄口座と多通貨口座を開設できます。" },
      howOpenBank: { q: "銀行口座はどのように開設しますか？", a: "エリートビザとメンバーカードがあれば、バンコク銀行やカシコン銀行の支店で開設できます。" },
      drivingLicense: { q: "タイの運転免許証はどのように申請しますか？", a: "タイランドエリートがEPLサービスを通じて運転免許証の取得を支援します。" },
      transferService: { q: "空港送迎サービスはどのように依頼しますか？", a: "メンバーコンタクトセンターにフライト詳細をお知らせください。5時間前までに予約。" },
      epaService: { q: "エリート・パーソナル・アシスタント（EPA）サービスとは？", a: "空港でのファストトラック入国審査と荷物支援を行うタイランドエリートスタッフです。" },
      eplService: { q: "エリート・パーソナル・リエゾン（EPL）サービスとは？", a: "バンコクでの政府サービス支援（滞在延長、ビザ貼付、銀行口座開設など）。" },
      ninetyDayReport: { q: "90日届出はどのように提出しますか？", a: "バンコクのタイランドエリート本社でパスポートとTM47フォームを提出できます。" },
      stayExtensionReport: { q: "滞在延長はいつ行う必要がありますか？", a: "PEビザ保持者は年1回の滞在延長が必要です。" },
      tm30: { q: "TM30とは？", a: "外国人の滞在を24時間以内に届け出る家主用の届出フォームです。" },
      tm30Who: { q: "TM30の提出責任者は誰ですか？", a: "責任は家主、ホテル、サービスアパートメントにあります。" },
      tm30Purpose: { q: "TM30規則の目的は？", a: "政府が各外国人の滞在場所を追跡するためです。" },
      tm30HowTo: { q: "TM30はどのように届け出ますか？", a: "家主が所有権証書と賃貸契約書のコピーを準備し、入国管理局に届け出ます。" },
      residenceCert: { q: "居住証明書はどのように取得しますか？", a: "自国の大使館またはタイの入国管理局に請求できます。" },
      childrenVisa: { q: "子供にもタイのビザが必要ですか？", a: "はい、あらゆる年齢の外国人に有効なタイのビザが必要です。" },
    },
  },
  news: {
    metaTitle: "タイランドエリートニュース＆アップデート",
    metaDescription: "タイランドエリートメンバーシッププログラム、ビザアップデート、限定イベントの最新ニュース。",
    title: "ニュース＆アップデート",
    subtitle: "タイランドエリートプログラムのアップデートとタイのライフスタイルニュース。",
    readMore: "続きを読む",
    cmsNote: "さらに多くの記事が近日公開予定。CMS連携準備中。",
    articles: {
      article1: { date: "2026年2月10日", title: "タイランドエリートが40,000メンバーのマイルストーン達成", excerpt: "タイランドエリートプログラムは正式に40,000人のアクティブメンバーを突破しました。" },
      article2: { date: "2026年1月28日", title: "2026年の新プリビレッジパートナー追加", excerpt: "タイランドエリートが15の新しいラグジュアリーホテル、ゴルフ場、ウェルネスセンターと提携。" },
      article3: { date: "2026年1月15日", title: "迅速な承認のための更新された申請プロセス", excerpt: "タイランド・プリビレッジ・カード・カンパニーが申請プロセスを合理化し、承認期間を4〜6週間に短縮。" },
      article4: { date: "2025年12月20日", title: "タイがデジタルノマドのトップ目的地に", excerpt: "タイはリモートワーカーとデジタルノマドにとって世界トップクラスの目的地であり続けています。" },
      article5: { date: "2025年12月5日", title: "限定メンバーイベント：バンコクガラディナー", excerpt: "タイランドエリートがバンコクで限定ガラディナーを開催。" },
      article6: { date: "2025年11月18日", title: "エリートメンバー向けヘルスケア特典拡大", excerpt: "バンコクの主要病院との新たな提携により、優先的なヘルスケアアクセスを提供。" },
    },
  },
  privileges: {
    metaTitle: "タイランド特典 – タイランドエリートメンバー限定サービス＆特典",
    metaDescription: "タイランドエリートメンバーが利用できるすべての特典：VIP空港ファストトラック、リムジン送迎、スパ、ゴルフ、行政手続き支援、ヘルスケア。",
    badge: "タイランド特典",
    title: "タイランドエリート特典",
    subtitle: "タイランドエリートメンバーとして、VIP空港サービスからラグジュアリーライフスタイル特典、行政手続き支援、プレミアムヘルスケアまで限定特典にアクセスできます。",
    intro1: "タイランドエリートメンバーとして、タイでの生活をより簡単で楽しくする包括的な特典をご利用いただけます。",
    intro2: "2023年10月1日の新プログラム開始以来、各メンバーシップティアには年間のプリビレッジポイントが付与されます。",
    highlights: {
      visa: { title: "長期マルチエントリービザ", desc: "タイで最も長いビザ — 5年間更新可能なプリビレッジ・エントリー・ビザ（PE）。" },
      recognition: { title: "VIP認定", desc: "主要空港でエリート・パーソナル・アシスタントによるファーストクラスの待遇。" },
      facilitation: { title: "行政手続き支援", desc: "ビザ、入国管理、銀行口座、運転免許証の個別サポート。" },
      lifestyle: { title: "限定ライフスタイル特典", desc: "ラグジュアリーホテル、スパ、ゴルフ場、レストランでの特別割引とVIPアクセス。" },
    },
    pointsCta: { title: "プリビレッジポイント — 選ぶ自由", desc: "各メンバーシップには限定サービスと引き換え可能な年間プリビレッジポイントが含まれます。", button: "プリビレッジポイントを見る" },
    relatedGuides: {
      title: "タイランドエリート会員向けの便利なガイド",
      intro: "銀行口座開設、運転免許、税務、滞在延長、TM30 報告など、会員がよく利用するサービスのステップバイステップ ガイドです。",
    },
    categories: {
      arrival: { title: "到着＆出発サービス", overview: "国際線到着時にエリート・パーソナル・アシスタントがお出迎え。",
        items: { fastTrack: { title: "VIP空港ファストトラック", desc: "主要空港で入国審査の行列をスキップ。" }, limousine: { title: "リムジン送迎", desc: "空港とご自宅・ホテル間の無料ラグジュアリー車両送迎。" }, lounge: { title: "限定空港ラウンジ", desc: "無料の食事と飲み物が楽しめる限定ラウンジ。" } },
      },
      lifestyle: { title: "ライフスタイル＆レジャー", overview: "タイの最高の施設で限定割引とVIP体験。",
        items: { spa: { title: "スパトリートメント", desc: "タイの最高のスパでの限定アクセスと割引。" }, golf: { title: "ゴルフパラダイス", desc: "プレミアムゴルフ場での無料ラウンドと割引グリーンフィー。" }, dining: { title: "ファインダイニング＆エンターテインメント", desc: "トップレストランでの特別オファーとVIPイベントアクセス。" }, shopping: { title: "VIPショッピング", desc: "主要ショッピングセンターでの限定割引。" } },
      },
      government: { title: "行政手続き支援", overview: "重要書類に関するタイ政府機関への個別サポート。",
        items: { immigration: { title: "90日届出", desc: "タイランドエリートスタッフが90日入国管理届出を代行。" }, drivingLicense: { title: "タイ運転免許証", desc: "EPLサービスによる運転免許証申請支援。" }, bankAccount: { title: "銀行口座開設", desc: "バンコク銀行・カシコン銀行での迅速な口座開設。" }, workPermit: { title: "エリート・パーソナル・リエゾン（EPL）", desc: "滞在延長、ビザ貼付、銀行口座開設などの行政サービス支援。" } },
      },
      health: { title: "プレミアムヘルスケア＆ウェルビーイング", overview: "タイのワールドクラスの医療サービスに優先アクセス。",
        items: { healthCheck: { title: "年間健康診断", desc: "プラチナティア以上で国際基準の病院での無料年間健康診断。" }, insurance: { title: "保険＆アドバイザリー", desc: "駐在員向けのカスタマイズされた健康・旅行保険。" }, dental: { title: "歯科＆ウェルネス", desc: "プレミアムクリニックでの割引歯科サービスとフィットネス会員。" } },
      },
    },
  },
  howToApply: {
    metaTitle: "タイランドエリートの申請方法 – ステップバイステップガイド",
    metaDescription: "タイランドエリートメンバーシップの申請方法。承認後にのみ支払いのシンプルな6ステッププロセス。",
    title: "タイランドエリートメンバーになるには？",
    subtitle: "申請からメンバーシップ有効化まで、シンプルで透明なプロセス。承認後にのみ支払い。",
    steps: {
      step1: {
        title: "ステップ1. ライフスタイルに合ったメンバーシップを選択",
        desc: "タイランドエリートのメンバーシップは、会員の様々なニーズとライフスタイルに合わせて設計されています。",
        details: "タイプ：個人または家族。期間：5年、10年、15年、または20年。各メンバーシップをご確認いただくか、お気軽にお問い合わせください。",
      },
      step2: {
        title: "ステップ2. 申請書を提出",
        desc: "オンラインで申請を開始するか、最新の申請書についてお問い合わせください。",
        details: "申請プロセスは、申請ポータルまたはメールを通じて100%オンラインで行われます。申請の選択や記入にお手伝いが必要な場合は、お気軽にお問い合わせください。電話、ビデオ通話、WhatsApp、メールで対応可能です。",
      },
      step3: {
        title: "ステップ3. 入国管理局の承認を待つ（4〜8週間）",
        desc: "申請書類は入国管理局に提出され、バックグラウンドチェックが行われます。",
        details: "通常このプロセスは約8週間かかりますが、国籍によってはそれ以上かかる場合があります。承認されると、承認書が記載されたメールが届きます。",
      },
      step4: {
        title: "ステップ4. 支払い",
        desc: "承認後、支払いのご案内をお送りします。",
        details: "銀行振込、クレジットカードなど複数の支払い方法をご利用いただけます。支払い後、支払い証明書をお送りください。承認前の支払いは不要です。",
      },
      step5: {
        title: "ステップ5. メンバーシップの有効化",
        desc: "支払い確認後、7営業日以内にメンバーシップが有効化されます。",
        details: "メンバーシップが有効化されると、コンシェルジュ、プリビレッジポイント、パートナー割引など、含まれるサービスをご利用いただけます。",
      },
      step6: {
        title: "ステップ6. タイランドエリートビザの貼付",
        desc: "タイランドエリートメンバーになり、メンバーIDを受け取った後、最低5日前に予約してビザを貼付できます。",
        details: "海外からバンコク・スワンナプーム空港、プーケット国際空港、チェンマイ国際空港に到着する場合、到着時にビザを取得できます。すでにタイ国内にいる場合は、バンコク・チェーンワッタナーの入国管理局でビザを貼付できます。",
      },
    },
    docsTitle: "必要書類",
    docsSubtitle: "スムーズな申請のためにこれらの書類をご準備ください。",
    docs: {
      passport: { title: "パスポートコピー", desc: "有効なパスポートのカラースキャン。" },
      photo: { title: "写真（パスポートサイズ）", desc: "白い背景の最近のパスポートサイズの写真。" },
      form: { title: "申請書", desc: "希望するメンバーシップの申請書（記入・署名済み、記入のお手伝いをします）。" },
      proof: { title: "親族関係証明", desc: "婚姻証明書、出生証明書 — 家族申請の場合のみ必要。" },
    },
    startButton: "申請を開始",
    helpNote: "ご質問がありますか？今すぐお問い合わせください",
  },
  apply: {
    metaTitle: "タイランドエリートメンバーシップにオンライン申請",
    metaDescription: "タイランドエリートメンバーシップにオンラインで申請。承認後にのみ支払いの安全な申請プロセス。",
    title: "オンライン申請",
    subtitle: "タイランドエリートメンバーシップの申請を開始。シンプル、安全、承認後にのみ支払い。",
    guarantees: { secure: "100%安全＆暗号化", fast: "24時間以内に返信", approved: "承認後にのみ支払い" },
    portalTitle: "タイランドエリート申請ポータル",
    portalDesc: "ポータルに登録し、すべての書類を安全に提出。申請の進捗を追跡し、担当エージェントと直接やり取り。",
    portalIntro: "アカウントを作成またはログインして、申請書を提出し進捗を確認しましょう。",
    disclaimer: "申請を提出することで、プライバシーポリシーに同意したものとみなされます。入国管理局の承認前に支払いは必要ありません。",
    openDirectText: "上記の申請ポータルが表示されませんか？",
    openDirectCta: "新しいタブでポータルを直接開く",
    tabLogin: "ログイン",
    tabRegister: "登録",
  },
  privacy: {
    metaTitle: "プライバシーポリシー – タイランドエリートGSSA",
    metaDescription: "タイランドエリートGSSAが個人情報をどのように収集、使用、保護するかについてお読みください。",
    title: "プライバシーポリシー",
    lastUpdated: "最終更新：2026年2月",
    sections: {
      collection: { title: "収集する情報", content: "タイランドエリートへの申請時やお問い合わせ時に自発的に提供される個人情報を収集します。" },
      usage: { title: "情報の使用方法", content: "タイランドエリートメンバーシップ申請の処理やコミュニケーションに個人情報を使用します。" },
      sharing: { title: "情報の共有", content: "申請処理に必要な範囲でタイランド・プリビレッジ・カード・カンパニー・リミテッドと情報を共有します。" },
      security: { title: "データセキュリティ", content: "個人情報を保護するための適切な技術的・組織的措置を実施しています。" },
      cookies: { title: "クッキー", content: "ブラウジング体験の向上とサイトトラフィックの分析にクッキーを使用しています。" },
      rights: { title: "あなたの権利", content: "個人情報へのアクセス、修正、更新、削除の権利があります。" },
      contact: { title: "お問い合わせ", content: "このプライバシーポリシーに関するご質問はinfo@thailand-elite.comまでお問い合わせください。" },
    },
  },
  membershipDetail: {
    backToMemberships: "メンバーシップに戻る",
    privilegesTitle: "含まれる特典",
    conditionsTitle: "メンバーシップ条件",
    familyOffer: "家族割引あり",
    faqTitle: "よくある質問",
    disclaimer: "タイランドエリートのメンバーシップと申請者/メンバーの資格は入国管理局の承認に基づきます。",
    validity: "有効期間",
    membershipFee: "メンバーシップ費用",
    privilegePoints: "ポイント / 年",
    compareFeature: "項目",
    bronze: {
      metaTitle: "タイランドエリートブロンズメンバーシップ – 5年ビザ | THB 650,000", metaDescription: "タイランドエリートブロンズ — 空港ファストトラックとコンシェルジュサービス付き5年ビザ。THB 650,000。",
      badge: "5年メンバーシップ", title: "ブロンズメンバーシップ", tagline: "快適と利便性の5年間メンバーシップ",
      intro: "ブロンズカードは、タイでの限定5年間体験へのエントリーポイントです。THB 650,000の一回払いで5年間のメンバーシップをお楽しみください。注意：ブロンズの新規お申し込みは2026年12月31日までです。",
      points: "", cta: "ブロンズに申請", familyDiscount: "",
      privileges: ["ファストトラック入国審査：無制限", "チェーンワッタナラウンジアクセス：無制限", "銀行口座開設支援", "メンバーコンタクトセンター24/7", "90日届出サービス", "EPLサービス：メンバーシップにつき1回", "EPAサービス：無制限", "Stay、Travel、Leisureカテゴリの割引", "更新可能な5年マルチエントリービザ", "入国ごとに延長可能な1年滞在"],
      privilegeGroups: [
        { title: "ビザ特典", items: [
          "更新可能な5年マルチエントリービザ",
          "入国ごとに延長可能な1年間の滞在",
          "90日届出サービス（バンコク本社）"
        ] },
        { title: "空港特典", items: [
          "無制限のファストトラック入国審査（スワンナプーム、チェンマイ、プーケット）",
          "無制限のチェーンワッタナラウンジアクセス"
        ] },
        { title: "ライフスタイル＆行政特典", items: [
          "銀行口座開設支援",
          "メンバーコンタクトセンター（MCC）24時間対応",
          "Elite Personal Liaison（EPL）：メンバーシップにつき1回",
          "Stay、Travel、Leisure カテゴリーの割引"
        ] }
      ],
      conditions: [{ label: "アップグレード", value: "可" }, { label: "更新可能", value: "可" }, { label: "譲渡", value: "譲渡不可 / 返金不可" }],
      faqs: [
        { q: "タイランドエリート ブロンズメンバーシップの費用はいくらですか？", a: "ブロンズメンバーシップの費用は一回限りの会員費 THB 650,000 です。新規お申し込みは2026年12月31日までです。" },
        { q: "ブロンズメンバーシップの有効期間はどのくらいですか？", a: "ブロンズメンバーシップは5年間有効で、更新可能なマルチエントリービザと入国ごとに延長可能な1年間の滞在が付帯します。" },
        { q: "ブロンズメンバーシップにプリビレッジポイントは含まれますか？", a: "いいえ。ブロンズはエントリーレベルのティアで、年間プリビレッジポイントは含まれません。ゴールド以上のティアにはプリビレッジポイントが含まれます。" },
        { q: "ブロンズ会員はタイに1年間通して滞在できますか？", a: "はい。会員は入国ごとに1年間の滞在スタンプを受け取り、スタンプの期限が切れる前にタイを出国しなければ、入国管理局で滞在を延長できます。" },
        { q: "ブロンズメンバーシップに家族を追加できますか？", a: "いいえ。ブロンズは個人向けメンバーシップです。家族会員オプションはプラチナ、ダイヤモンド、リザーブで利用できます。" },
        { q: "ブロンズメンバーシップでタイで働けますか？", a: "いいえ。タイランドエリート／Thailand Privilege は労働許可証の代わりにはなりません。就労を希望する会員は、適切な就労許可を取得する必要があります。" },
        { q: "ブロンズメンバーシップでタイの銀行口座を開設できますか？", a: "はい。銀行口座開設支援は会員が利用できる主要なサポートサービスの一つです。" },
        { q: "ブロンズメンバーシップは返金可能ですか？", a: "いいえ。メンバーシップは譲渡不可・返金不可です。" },
        { q: "後でブロンズからアップグレードできますか？", a: "はい。ブロンズメンバーシップはゴールド、プラチナ、ダイヤモンド、リザーブなどの上位ティアにアップグレードできます。" }
      ],
      comparison: {
        title: "ブロンズ対ゴールド：どちらの5年メンバーシップが最適？",
        intro: "ブロンズは最もアクセスしやすい5年タイランドエリートメンバーシップで、最も低い費用で、年間プリビレッジポイントはありません。ゴールドは、年間20プリビレッジポイントと追加のプレミアムサービスを備え、より充実したライフスタイル体験を求める会員に適しています。",
        colA: "ブロンズ",
        colB: "ゴールド",
        highlight: 0,
        rows: [
          { feature: "有効期間", a: "5年", b: "5年" },
          { feature: "メンバーシップ費用", a: "THB 650,000", b: "THB 900,000" },
          { feature: "プリビレッジポイント / 年", a: "0", b: "20" },
          { feature: "おすすめの方", a: "ビザ重視の申請者", b: "ビザ＋ライフスタイル特典" }
        ]
      }
    },
    gold: {
      metaTitle: "タイランドエリートゴールドメンバーシップ – 5年ビザ | THB 900,000", metaDescription: "タイランドエリートゴールド — 年間20ポイント付き5年ビザ。THB 900,000。",
      badge: "5年プレミアムメンバーシップ", title: "ゴールドメンバーシップ", tagline: "こだわりを持つ方のための5年間メンバーシップ",
      intro: "ゴールドカードは、タイでの充実した5年間の旅への入口です。THB 900,000のメンバーシップ費用と年間20ポイント。",
      points: "20", cta: "ゴールドに申請", familyDiscount: "",
      privileges: ["更新可能な5年マルチエントリービザ", "入国ごとに延長可能な1年滞在", "VIP出迎え＆見送り", "迅速な入国審査", "限定ラウンジ", "年間20プリビレッジポイント", "入国管理＆90日届出", "運転免許証支援", "銀行口座開設支援", "ビジネスネットワーキングサポート", "メンバーコンタクトセンター：英語24/7、韓国語、中国語、日本語"],
      privilegeGroups: [
        { title: "ビザ特典", items: [
          "更新可能な5年マルチエントリービザ",
          "入国ごとに延長可能な1年間の滞在",
          "入国管理サービス＆90日届出"
        ] },
        { title: "空港特典", items: [
          "到着・出発時の VIP 出迎えとエスコート",
          "迅速な入国審査・パスポートコントロール",
          "専用の到着・出発ラウンジ"
        ] },
        { title: "ライフスタイル＆行政特典", items: [
          "年間20プリビレッジポイントの利用",
          "運転免許証の取得手続き支援",
          "銀行口座開設支援",
          "ビジネスネットワーキングサポート",
          "メンバーコンタクトセンター：英語24時間対応（韓国語、中国語、日本語）"
        ] }
      ],
      conditions: [{ label: "アップグレード", value: "可" }, { label: "更新可能", value: "可" }, { label: "譲渡", value: "譲渡不可 / 返金不可" }],
      faqs: [
        { q: "タイランドエリート ゴールドメンバーシップの費用はいくらですか？", a: "ゴールドメンバーシップの費用は一回限りの会員費 THB 900,000 です。" },
        { q: "ゴールドメンバーシップの有効期間はどのくらいですか？", a: "ゴールドメンバーシップは5年間有効です。" },
        { q: "ゴールドメンバーシップにはプリビレッジポイントがいくつ含まれますか？", a: "ゴールド会員は年間20プリビレッジポイントを受け取ります。" },
        { q: "ゴールド会員はタイに1年間通して滞在できますか？", a: "はい。会員は入国ごとに1年間の滞在スタンプを受け取り、スタンプの期限が切れる前にタイを出国しなければ、入国管理局で滞在を延長できます。" },
        { q: "ゴールドメンバーシップに家族を追加できますか？", a: "いいえ。ゴールドは個人向けメンバーシップです。家族会員オプションはプラチナ、ダイヤモンド、リザーブで利用できます。" },
        { q: "ゴールドメンバーシップでタイで働けますか？", a: "いいえ。タイランドエリート／Thailand Privilege は労働許可証の代わりにはなりません。就労を希望する会員は、適切な就労許可を取得する必要があります。" },
        { q: "ゴールドメンバーシップでタイの銀行口座を開設できますか？", a: "はい。銀行口座開設支援は会員が利用できる主要なサポートサービスの一つです。" },
        { q: "ゴールドメンバーシップは返金可能ですか？", a: "いいえ。メンバーシップは譲渡不可・返金不可です。" },
        { q: "後でゴールドからアップグレードできますか？", a: "はい。ゴールドメンバーシップはプラチナ、ダイヤモンド、リザーブなどの上位ティアにアップグレードできます。" }
      ],
      comparison: {
        title: "ゴールド対ブロンズ：どちらの5年メンバーシップを選ぶべき？",
        intro: "ブロンズはエントリーレベルの5年タイランドエリートメンバーシップで、費用が低く、年間プリビレッジポイントはありません。ゴールドは、年間20プリビレッジポイントと追加のプレミアムサービスを備え、より充実したライフスタイル体験を求める会員により適しています。",
        colA: "ブロンズ",
        colB: "ゴールド",
        highlight: 1,
        rows: [
          { feature: "有効期間", a: "5年", b: "5年" },
          { feature: "メンバーシップ費用", a: "THB 650,000", b: "THB 900,000" },
          { feature: "プリビレッジポイント / 年", a: "0", b: "20" },
          { feature: "おすすめの方", a: "ビザ重視の申請者", b: "ビザ＋ライフスタイル特典" }
        ]
      }
    },
    platinum: {
      metaTitle: "タイランドエリートプラチナメンバーシップ – 10年ビザ | THB 1,500,000", metaDescription: "タイランドエリートプラチナ — 年間35ポイントと家族割引付き10年ビザ。",
      badge: "10年エリートメンバーシップ", title: "プラチナメンバーシップ", tagline: "タイでの10年間の栄誉",
      intro: "プラチナエリートメンバーシップで贅沢の世界へ。THB 1,500,000で年間35ポイント。",
      points: "35", cta: "プラチナに申請", familyDiscount: "家族メンバーはTHB 750,000/人で参加可能（2026年12月31日まで、通常THB 1,000,000）",
      privileges: ["更新可能な5年マルチエントリービザ（全10年カバー）", "入国ごとに延長可能な1年滞在", "VIP出迎え", "迅速な入国審査", "限定ラウンジ", "年間35プリビレッジポイント", "入国管理＆90日届出", "運転免許証支援", "銀行口座開設支援", "ビジネスネットワーキングサポート", "家族メンバー：1人THB 1,000,000（2026年12月31日までプロモTHB 750,000）", "メンバーコンタクトセンター：英語24/7、韓国語、中国語、日本語"],
      privilegeGroups: [
        { title: "ビザ特典", items: [
          "更新可能な5年マルチエントリービザ（全10年カバー）",
          "入国ごとに延長可能な1年間の滞在",
          "入国管理サービス＆90日届出"
        ] },
        { title: "空港特典", items: [
          "到着・出発時の VIP 出迎えとエスコート",
          "迅速な入国審査・パスポートコントロール",
          "専用の到着・出発ラウンジ"
        ] },
        { title: "ライフスタイル＆行政特典", items: [
          "年間35プリビレッジポイントの利用",
          "運転免許証の取得手続き支援",
          "銀行口座開設支援",
          "ビジネスネットワーキングサポート",
          "対象家族：配偶者、両親、子供（1人 THB 1,000,000）",
          "メンバーコンタクトセンター：英語24時間対応（韓国語、中国語、日本語）"
        ] }
      ],
      conditions: [{ label: "アップグレード", value: "可" }, { label: "更新可能", value: "可" }, { label: "譲渡", value: "譲渡不可 / 返金不可" }],
      faqs: [
        { q: "タイランドエリート プラチナメンバーシップの費用はいくらですか？", a: "プラチナメンバーシップの費用は一回限りの会員費 THB 1,500,000 です。家族メンバーは2026年12月31日まで1人75万バーツ（通常 THB 1,000,000）で参加できます。" },
        { q: "プラチナメンバーシップの有効期間はどのくらいですか？", a: "プラチナメンバーシップは10年間有効です。" },
        { q: "プラチナメンバーシップにはプリビレッジポイントがいくつ含まれますか？", a: "プラチナ会員は年間35プリビレッジポイントを受け取ります。" },
        { q: "プラチナ会員はタイに1年間通して滞在できますか？", a: "はい。会員は入国ごとに1年間の滞在スタンプを受け取り、スタンプの期限が切れる前にタイを出国しなければ、入国管理局で滞在を延長できます。" },
        { q: "プラチナメンバーシップに家族を追加できますか？", a: "はい。対象となる家族 — 配偶者、両親、子供 — は2026年12月31日まで1人75万バーツ（通常 THB 1,000,000）で参加でき、それぞれが独自のビザと全特典を受け取ります。" },
        { q: "プラチナメンバーシップでタイで働けますか？", a: "いいえ。タイランドエリート／Thailand Privilege は労働許可証の代わりにはなりません。就労を希望する会員は、適切な就労許可を取得する必要があります。" },
        { q: "プラチナメンバーシップでタイの銀行口座を開設できますか？", a: "はい。銀行口座開設支援は会員が利用できる主要なサポートサービスの一つです。" },
        { q: "プラチナメンバーシップは返金可能ですか？", a: "いいえ。メンバーシップは譲渡不可・返金不可です。" },
        { q: "後でプラチナからアップグレードできますか？", a: "はい。プラチナメンバーシップはダイヤモンドやリザーブなどの上位ティアにアップグレードできます。" }
      ],
      comparison: {
        title: "プラチナ対ゴールド：10年か5年か？",
        intro: "ゴールドは個人向けに5年間のメンバーシップを提供し、プラチナは有効期間を10年に倍増させ、プリビレッジポイントを増やし、家族会員制度を開きます。プラチナは、より長期の滞在を計画している方や、家族を含めたい方に適しています。",
        colA: "ゴールド",
        colB: "プラチナ",
        highlight: 1,
        rows: [
          { feature: "有効期間", a: "5年", b: "10年" },
          { feature: "メンバーシップ費用", a: "THB 900,000", b: "THB 1,500,000" },
          { feature: "プリビレッジポイント / 年", a: "20", b: "35" },
          { feature: "家族会員", a: "利用不可", b: "THB 1,000,000 / 人" },
          { feature: "おすすめの方", a: "個人、5年スパン", b: "より長期の滞在＋家族オプション" }
        ]
      }
    },
    diamond: {
      metaTitle: "タイランドエリートダイヤモンドメンバーシップ – 15年ビザ | THB 2,500,000", metaDescription: "タイランドエリートダイヤモンド — 年間55ポイントと家族割引付き15年ビザ。",
      badge: "15年プレミアムメンバーシップ", title: "ダイヤモンドメンバーシップ", tagline: "15年間の比類なきタイのラグジュアリー",
      intro: "ダイヤモンドエリートメンバーシップでタイ体験を格上げ。THB 2,500,000と年間55ポイント。",
      points: "55", cta: "ダイヤモンドに申請", familyDiscount: "家族メンバーはTHB 750,000/人（2026年12月31日まで、通常THB 1,500,000）",
      privileges: ["更新可能な5年マルチエントリービザ（全15年カバー）", "入国ごとに延長可能な1年滞在", "VIP出迎え", "迅速な入国審査", "限定ラウンジ", "年間55プリビレッジポイント", "入国管理＆90日届出", "運転免許証支援", "銀行口座開設支援", "ビジネスネットワーキングサポート", "家族メンバー：1人THB 1,500,000（2026年12月31日までプロモTHB 750,000）", "メンバーコンタクトセンター：英語24/7、韓国語、中国語、日本語"],
      privilegeGroups: [
        { title: "ビザ特典", items: [
          "更新可能な5年マルチエントリービザ（全15年カバー）",
          "入国ごとに延長可能な1年間の滞在",
          "入国管理サービス＆90日届出"
        ] },
        { title: "空港特典", items: [
          "到着・出発時の VIP 出迎えとエスコート",
          "迅速な入国審査・パスポートコントロール",
          "専用の到着・出発ラウンジ"
        ] },
        { title: "ライフスタイル＆行政特典", items: [
          "年間55プリビレッジポイントの利用",
          "運転免許証の取得手続き支援",
          "銀行口座開設支援",
          "ビジネスネットワーキングサポート",
          "対象家族：配偶者、両親、子供（1人 THB 1,500,000）",
          "メンバーコンタクトセンター：英語24時間対応（韓国語、中国語、日本語）"
        ] }
      ],
      conditions: [{ label: "アップグレード", value: "可" }, { label: "更新可能", value: "可" }, { label: "譲渡", value: "譲渡不可 / 返金不可" }],
      faqs: [
        { q: "タイランドエリート ダイヤモンドメンバーシップの費用はいくらですか？", a: "ダイヤモンドメンバーシップの費用は一回限りの会員費 THB 2,500,000 です。家族メンバーは2026年12月31日まで1人75万バーツ（通常 THB 1,500,000）で参加できます。" },
        { q: "ダイヤモンドメンバーシップの有効期間はどのくらいですか？", a: "ダイヤモンドメンバーシップは15年間有効です。" },
        { q: "ダイヤモンドメンバーシップにはプリビレッジポイントがいくつ含まれますか？", a: "ダイヤモンド会員は年間55プリビレッジポイントを受け取ります。" },
        { q: "ダイヤモンド会員はタイに1年間通して滞在できますか？", a: "はい。会員は入国ごとに1年間の滞在スタンプを受け取り、スタンプの期限が切れる前にタイを出国しなければ、入国管理局で滞在を延長できます。" },
        { q: "ダイヤモンドメンバーシップに家族を追加できますか？", a: "はい。対象となる家族 — 配偶者、両親、子供 — は2026年12月31日まで1人75万バーツ（通常 THB 1,500,000）で参加でき、それぞれが独自のビザと全特典を受け取ります。" },
        { q: "ダイヤモンドメンバーシップでタイで働けますか？", a: "いいえ。タイランドエリート／Thailand Privilege は労働許可証の代わりにはなりません。就労を希望する会員は、適切な就労許可を取得する必要があります。" },
        { q: "ダイヤモンドメンバーシップでタイの銀行口座を開設できますか？", a: "はい。銀行口座開設支援は会員が利用できる主要なサポートサービスの一つです。" },
        { q: "ダイヤモンドメンバーシップは返金可能ですか？", a: "いいえ。メンバーシップは譲渡不可・返金不可です。" },
        { q: "後でダイヤモンドからアップグレードできますか？", a: "はい。ダイヤモンドメンバーシップは、招待制のフラグシップティアであるリザーブにアップグレードできます。" }
      ],
      comparison: {
        title: "ダイヤモンド対プラチナ：どちらの長期メンバーシップ？",
        intro: "プラチナは10年をカバーし、ダイヤモンドは居住期間を15年に延長し、毎年より多くのプリビレッジポイントを付与します。どちらも家族会員制度を提供しており、ダイヤモンドは招待制のリザーブティアの下で、最も長い実用的なスパンを希望する会員に適しています。",
        colA: "プラチナ",
        colB: "ダイヤモンド",
        highlight: 1,
        rows: [
          { feature: "有効期間", a: "10年", b: "15年" },
          { feature: "メンバーシップ費用", a: "THB 1,500,000", b: "THB 2,500,000" },
          { feature: "プリビレッジポイント / 年", a: "35", b: "55" },
          { feature: "家族会員", a: "THB 1,000,000 / 人", b: "THB 1,500,000 / 人" },
          { feature: "おすすめの方", a: "10年スパン", b: "15年スパン、より多くのポイント" }
        ]
      }
    },
    reserve: {
      metaTitle: "タイランドエリートリザーブメンバーシップ – 20年ビザ | THB 5,000,000", metaDescription: "タイランドエリートリザーブ — 招待制のみの20年メンバーシップ。年間120ポイント、譲渡可能。",
      badge: "20年招待制限定", title: "リザーブメンバーシップ", tagline: "タイ特権の頂点",
      intro: "究極のラグジュアリーと排他性を求める方のために。招待制限定で20年間の有効期間と年間120ポイント。",
      points: "120", cta: "リザーブメンバーシップについて問い合わせ", familyDiscount: "家族メンバーはTHB 750,000/人（2026年12月31日まで、通常THB 2,000,000）",
      privileges: ["更新可能な5年マルチエントリービザ（全20年カバー）", "入国ごとに延長可能な1年滞在", "VIP出迎え", "迅速な入国審査", "限定ラウンジ", "年間120プリビレッジポイント", "入国管理＆90日届出", "運転免許証支援", "銀行口座開設支援", "ビジネスネットワーキングサポート", "メンバーシップ譲渡可能", "メンバーコンタクトセンター：英語24/7、韓国語、中国語、日本語"],
      privilegeGroups: [
        { title: "ビザ特典", items: [
          "更新可能な5年マルチエントリービザ（全20年カバー）",
          "入国ごとに延長可能な1年間の滞在",
          "入国管理サービス＆90日届出"
        ] },
        { title: "空港特典", items: [
          "到着・出発時の VIP 出迎えとエスコート",
          "迅速な入国審査・パスポートコントロール",
          "専用の到着・出発ラウンジ"
        ] },
        { title: "ライフスタイル＆行政特典", items: [
          "年間120プリビレッジポイントの利用",
          "運転免許証の取得手続き支援",
          "銀行口座開設支援",
          "ビジネスネットワーキングサポート",
          "譲渡可能なメンバーシップ",
          "対象家族：配偶者、両親、子供（1人 THB 2,000,000）",
          "メンバーコンタクトセンター：英語24時間対応（韓国語、中国語、日本語）"
        ] }
      ],
      conditions: [{ label: "招待", value: "招待制のみ" }, { label: "譲渡可能", value: "可" }, { label: "更新可能", value: "可" }],
      faqs: [
        { q: "タイランドエリート リザーブメンバーシップの費用はいくらですか？", a: "リザーブメンバーシップの費用は一回限りの会員費 THB 5,000,000 です。家族メンバーは2026年12月31日まで1人75万バーツ（通常 THB 2,000,000）で参加できます。" },
        { q: "リザーブメンバーシップの有効期間はどのくらいですか？", a: "リザーブメンバーシップは20年間有効です — タイランドエリートの全ティアの中で最長の有効期間です。" },
        { q: "リザーブメンバーシップの招待を受けるにはどうすればよいですか？", a: "リザーブメンバーシップは招待制のみです。ご関心をお寄せいただける場合は当チームにお問い合わせください。資格を評価し、手続きをご案内いたします。" },
        { q: "リザーブメンバーシップにはプリビレッジポイントがいくつ含まれますか？", a: "リザーブ会員は年間120プリビレッジポイントを受け取ります — 全ティアの中で最も多い付与数です。" },
        { q: "リザーブメンバーシップは譲渡可能ですか？", a: "はい。リザーブは唯一の譲渡可能なタイランドエリートメンバーシップで、ラグジュアリーの遺産を継承することができます。" },
        { q: "リザーブメンバーシップに家族を追加できますか？", a: "はい。対象となる家族 — 配偶者、両親、子供 — は2026年12月31日まで1人75万バーツ（通常 THB 2,000,000）で参加でき、それぞれが20年間の全期間にわたり独自のビザとリザーブの全特典を受け取ります。" },
        { q: "リザーブメンバーシップでタイで働けますか？", a: "いいえ。タイランドエリート／Thailand Privilege は労働許可証の代わりにはなりません。就労を希望する会員は、適切な就労許可を取得する必要があります。" },
        { q: "リザーブメンバーシップでタイの銀行口座を開設できますか？", a: "はい。銀行口座開設支援は会員が利用できる主要なサポートサービスの一つです。" },
        { q: "リザーブ会員はタイに1年間通して滞在できますか？", a: "はい。会員は入国ごとに1年間の滞在スタンプを受け取り、スタンプの期限が切れる前にタイを出国しなければ、入国管理局で滞在を延長できます。" }
      ],
      comparison: {
        title: "リザーブ対ダイヤモンド：究極のティア",
        intro: "ダイヤモンドは15年間のプレミアムメンバーシップを提供し、リザーブは招待制のフラグシップ — 20年間の居住、最高のプリビレッジポイント付与数、そしてプログラム内で唯一の譲渡可能なメンバーシップです。",
        colA: "ダイヤモンド",
        colB: "リザーブ",
        highlight: 1,
        rows: [
          { feature: "有効期間", a: "15年", b: "20年" },
          { feature: "メンバーシップ費用", a: "THB 2,500,000", b: "THB 5,000,000" },
          { feature: "プリビレッジポイント / 年", a: "55", b: "120" },
          { feature: "家族会員", a: "THB 1,500,000 / 人", b: "THB 2,000,000 / 人" },
          { feature: "譲渡可能", a: "不可", b: "可" },
          { feature: "アクセス", a: "一般申請", b: "招待制のみ" }
        ]
      }
    },
  },
  visa: {
    metaTitle: "タイランドエリートビザ – タイエリートビザ＆プリビレッジ・エントリー・ビザ（PE）",
    metaDescription: "タイランドエリートビザ（プリビレッジ・エントリー・ビザ）は5年間更新可能なマルチエントリービザ — タイで最長のビザです。",
    badge: "タイランド・プリビレッジ・エントリー・ビザ（PE）",
    title: "タイランドエリートビザ",
    subtitle: "タイエリートビザはタイで最長のビザ — 5年間更新可能なプリビレッジ・エントリー・ビザ。",
    whatIsTitle: "タイランドエリートビザとは？",
    intro1: "タイランドエリートビザ（公式名称：プリビレッジ・エントリー・ビザ、PE）は、タイランド・プリビレッジ・カードメンバー専用の特別な長期ビザです。",
    intro2: "5年間更新可能なマルチエントリービザで、入国ごとに1年間延長可能な滞在が認められます。",
    intro3: "タイランドエリートビザ、タイエリートビザ、タイランド・プリビレッジビザ、タイランド・プリビレッジ・エントリービザ — どの呼称でも、同じタイランドエリートプログラムを通じて発給される同一の公式長期滞在ビザです。50か国以上の40,000人を超えるメンバーを擁し、タイランドエリートはアジア初にして最も歴史と実績を持つ会員制居住プログラムです。",
    rebrandTitle: "タイランドエリートビザとタイランド・プリビレッジビザ — 2つの名称、1つのプログラム",
    rebrandIntro: "タイランドエリートビザとタイランド・プリビレッジビザは同じものかという質問をよく受けます。答えは「はい」 — どちらの名称も、同一の公式プログラムのもとで発給される全く同じ長期滞在ビザを指します。両者の関係をご説明します。",
    rebrandPoints: [
      { label: "プログラムのブランド名", value: "タイランドエリート — 2003年以来世界中で認知されている長年のプログラム名で、会員・代理店・メディアの間で今も最も一般的に使われる呼称です。" },
      { label: "発給機関", value: "ビザ自体はタイ入国管理局によって発給されます。その背景にある会員資格とプリビレッジカードは、タイ政府観光庁（TAT）傘下の国営企業である Thailand Privilege Card Co., Ltd. によって運営されています。Thailand Elite は公式の販売・サービスチャネルです。" },
      { label: "ビザの呼称", value: "タイランドエリートビザとタイランド・プリビレッジビザは同一ビザの互換可能な呼称です。一部の資料では Thai Elite Visa や Thailand Privilege Entry Visa とも呼ばれます。" },
      { label: "公式ビザカテゴリー", value: "Privilege Entry Visa（PE） — タイ入国管理局がパスポートに押印する法定のビザ種別。両ブランドの背景にある正式な技術名称です。" },
    ],
    rebrandConclusion: "実際には、すべての呼称はタイランドエリート会員資格によって付与され、Thailand Privilege Card Co., Ltd. が発給する同一の複数年居住ビザを指しています — 一度申請すれば、いずれの名称も安心してご使用いただけます。",
    rebrandLink: "Thailand Privilege Card の詳細を見る",
    rebrandApplyCta: "今すぐタイランドエリートに申し込む",
    locationsTitle: "タイランドエリートビザの取得場所",
    locationsSubtitle: "ビザはパスポートに貼付されます（最低3ページの空白ページが必要）。",
    locations: {
      suvarnabhumi: { title: "バンコク・スワンナプーム国際空港", desc: "国際線到着時のみ利用可能。メンバーコンタクトセンターを通じて最低5営業日前に予約。" },
      phuket: { title: "プーケット国際空港", desc: "国際線到着時のみ利用可能。メンバーコンタクトセンターを通じて最低5営業日前に予約。" },
      chiangMai: { title: "チェンマイ国際空港", desc: "国際線到着時のみ利用可能。メンバーコンタクトセンターを通じて最低5営業日前に予約。" },
      chaengWattana: { title: "入国管理局、チェーンワッタナ", desc: "完全予約制 — ラウンジ利用可能。メンバーコンタクトセンターを通じて最低7営業日前に予約。空き状況・順番待ちに依る。" },
    },
    dutiesTitle: "タイランドエリートビザ保持者の義務",
    dutiesSubtitle: "他のビザタイプと比べて簡素化された義務。",
    duties: {
      ninetyDay: { title: "90日届出（TM47）", desc: "90日以上連続滞在するすべての外国人は90日ごとに住所を届け出る必要があります。" },
      annualExtension: { title: "年間滞在延長", desc: "5年間のビザ有効期間にもかかわらず、各滞在は入国ごとに1年間に制限されます。" },
    },
    workTitle: "タイランドエリートビザで働けますか？",
    workDesc1: "プリビレッジ・エントリー・ビザは観光ビザに分類され、労働許可証を取得することはできません。",
    workDesc2: "労働許可証が必要な場合は、別途ノンイミグラントBビザを申請できます。",
    faqTitle: "タイランドエリートビザ — よくある質問",
    requirementsTitle: "タイランドエリートビザの要件",
    requirementsSubtitle: "タイランド・プリビレッジ・エントリー・ビザを申請するための資格要件。",
    tdac: {
      title: "ご到着前に TDAC を記入してください",
      desc: "タイランドエリート会員は、タイ入国の3日前までに Thailand Digital Arrival Card を記入し、確認書を旅行書類とともにご携帯ください。",
      link: "TDAC ガイドを読む",
    },
    howToApplyLink: "タイランドエリートメンバーになる方法 →",
    facts: {
      duration: { title: "5年間の有効期間", desc: "タイで最長の更新可能なマルチエントリービザ。" },
      multiEntry: { title: "無制限の入国", desc: "ビザ有効期間中、タイへの自由な出入国。" },
      extension: { title: "1年間の滞在延長", desc: "出国せずに入国ごとに1年間延長可能。" },
      renewal: { title: "無料更新", desc: "メンバーシップ期限まで無料でビザ更新。" },
    },
    faqs: {
      whatIsElite: { q: "タイランドエリートビザとは何ですか？", a: "タイランドエリートビザは、タイランドエリートプログラムの会員に対してタイ入国管理局が発給する長期滞在のマルチエントリービザです。正式名称は Privilege Entry Visa（PE）で、Thailand Privilege Visa とも呼ばれ、タイで取得できる最長のビザです — 会員ティアに応じて5年、10年、15年または20年の有効期間を持ち、入国ごとに更新可能な1年間の滞在期間が付与され、ボーダーラン（出入国を繰り返す行為）は不要です。" },
      whatIsPrivilege: { q: "Thailand Privilege Visa とは何ですか？", a: "Thailand Privilege Visa はタイランドエリートビザの別名で、タイランドエリート会員に付与される同一の長期滞在ビザです。各会員にプリビレッジカードを発給するタイの公式国営企業 Thailand Privilege Card Co., Ltd. に因んだ呼称です。法的には Privilege Entry Visa（PE）に分類され、会員ティアに応じて5年、10年、15年または20年有効です。" },
      sameVisa: { q: "タイランドエリートビザと Thailand Privilege Visa は同じビザですか？", a: "はい。タイランドエリートビザと Thailand Privilege Visa は同一プログラムを通じて発給される同じビザの2つの呼称です。タイランドエリートは世界的に認知されたプログラムブランドであり、Thailand Privilege Card Co., Ltd. は会員資格とビザを提供する機関です。法的なビザカテゴリー — Privilege Entry Visa（PE）— と会員特典は同一です。" },
      validity: { q: "タイランドエリート／Thailand Privilege Visa の有効期間はどれくらいですか？", a: "ビザの有効期間はタイランドエリート会員ティアに応じて5年、10年、15年または20年です — Bronze（5年）、Gold（5年・更新可能）、Platinum（10年）、Diamond（15年）、Reserve（20年・招待制）。マルチエントリーで、入国ごとに更新可能な1年間の滞在期間が付与され、会員期間中は無料で更新されます。" },
      cost: { q: "タイランドエリート／Thailand Privilege Visa の費用はいくらですか？", a: "タイランドエリート会員費は5年の Bronze ティアの THB 650,000（約 USD 18,000）から始まり、20年の Reserve ティアの THB 5,000,000 まであります。費用は一回限りの会員費で、年間更新料は不要で、ビザ自体も含まれています。現在のティア構成は会員資格ページをご覧ください。" },
      obtain: { q: "タイランドエリートビザの取得方法は？", a: "会員となり、タイランドエリート会員IDが発行された後、Member Contact Center に依頼することで5営業日以内にビザを取得できます。ビザは選択された場所 — バンコク・スワンナプーム空港、プーケット空港、チェンマイ空港、チェーンワッタナ入国管理局、または海外のタイ王国領事館 — でパスポートに貼付されます。" },
      where: { q: "Privilege Entry Visa はどこで受け取れますか？", a: "タイランドエリートビザはパスポート（3ページ以上の空白ページ要）に貼付されます。バンコク・スワンナプーム空港またはプーケット空港の国際線到着時、バンコクのチェーンワッタナ入国管理局、または居住国のタイ王国領事館で受領可能です。" },
      duties: { q: "タイエリートビザ保持者の義務は何ですか？", a: "タイランドエリート／Thailand Privilege Visa 保持者は90日ごとの住所届出（TM47）を行う必要があり、1年以上連続して滞在する場合は年次滞在延長を申請する必要があります。タイランドエリートスタッフが、バンコク、パタヤ、プーケット、チェンマイで両手続きをサポートします。" },
      reporting: { q: "90日届出の要件とは？", a: "タイに90日以上連続滞在するすべての外国人は、90日ごとに住所を届け出る必要があります。タイを出国し再入国するとカウンターはリセットされます。タイランドエリートは、バンコク（サトーン通り）、パタヤ、プーケット、チェンマイで代行サービスを提供しており、オンラインや郵送でも届出が可能です。" },
      extension: { q: "年次滞在延長はどのように行いますか？", a: "Thailand Privilege Visa は複数年の有効期間がありますが、各滞在は入国ごとに1年に制限されます。出国予定がない場合は Member Service に連絡し、滞在延長の公式レターを取得してください。手続きは簡単で、入国スタンプ期限の30日前から行えます。" },
      work: { q: "タイランドエリート／Thailand Privilege Visa で働くことはできますか？", a: "Privilege Entry Visa は観光ビザに分類されるため、労働許可証は含まれません。事業や収入が海外にある場合は、タイエリートビザを保有しつつ業務をリモートで行うことができます。タイ法人の株主や役員になることはできますが、実際に従業員として働くことはできません。労働には別途ノンイミグラントBビザを取得することができ、一部の会員は Flexible Plus プログラムにより PE ビザを労働許可用のノンイミグラントビザに転換することが可能です。" },
      family: { q: "家族も Thailand Privilege Visa を取得できますか？", a: "はい。Thailand Privilege Card の複数のティア（Gold Family、Platinum Family、Diamond Family、Reserve）には、配偶者、両親、子供のための家族会員資格が含まれており、それぞれが主会員と同じ条件で独自の Thailand Privilege Visa を受け取ります。各ティアの対象条件と料金は家族会員ページをご参照ください。" },
    },
    requirements: ["受理された国の外国パスポート（3ページ以上の空白、1年以上の有効期限）", "タイでのビザ超過滞在記録なし", "年齢制限なし（リザーブは20歳以上）", "いかなる国でも禁固刑なし（過失を除く）", "破産宣告を受けていないこと", "精神的に健全で能力があること", "入国管理局の承認が必要"],
  },
  thailandPrivilegeCard: {
    metaTitle: "Thailand Privilege Card — タイランドエリートビザを支える公式メンバーシップ",
    metaDescription: "Thailand Privilege Card は、Thailand Privilege Card Co., Ltd. が発行する公式メンバーシップです。タイランドエリートの長期滞在ビザを提供する国営機関。5〜20年ビザ、ファストトラック入国審査、コンシェルジュ＆ライフスタイル特典付き。",
    badge: "Thailand Privilege Card",
    title: "Thailand Privilege Card — タイランドエリートを支える公式メンバーシップ",
    subtitle: "Thailand Privilege Card Co., Ltd. は、タイランドエリートプログラムの会員資格を発行するタイの公式国営機関です。1回の申請で5〜20年の長期滞在ビザ、ファストトラック入国審査、政府コンシェルジュ、そして厳選されたライフスタイル特典が利用可能になります。",
    heroAuthorized: "認定 Global Sales & Services Agent（GSSA）",
    facts: {
      since: { value: "2003", label: "プログラム開始" },
      members: { value: "40,000+", label: "世界の会員数" },
      countries: { value: "50+", label: "代表国籍数" },
      official: { value: "Royal Thai", label: "国営機関運営" }
    },
    whatIsTitle: "Thailand Privilege Card とは？",
    whatIs1: "Thailand Privilege Card は、外国人がタイで合法的に長期滞在するための公式メンバーシップです。タイ観光スポーツ省傘下の国営機関である Thailand Privilege Card Co., Ltd. が発行し、2003年よりタイランドエリートプログラムを支えてきました。",
    whatIs2: "各メンバーシップには、Thailand Elite Visa（Thailand Privilege Visa とも呼ばれ、法的には Privilege Entry Visa（PE）に分類）が付帯します。これはティアに応じて5〜20年間有効なマルチエントリー長期滞在ビザであり、滞在・旅行・余暇・ウェルネス・資産管理パートナーで利用できる年間 Privilege Points も充実しています。主要タイ空港での迅速な入国審査、政府コンシェルジュサポート、Member Contact Center による24時間対応を享受できます。",
    whatIs3: "Thailand Elite は世界に認知されたプログラムブランドであり、Thailand Privilege Card Co., Ltd. はそのメンバーシップとビザを提供する機関です。どちらの名称も同一の公式プログラムを指しており、アジアで最も歴史と実績を持つ会員制居住プログラムです。",
    tiersTitle: "タイランドエリート メンバーシップ ティア",
    tiersIntro: "5つのタイランドエリート ティア、すべてに1枚の Thailand Privilege Card。ご自身のライフスタイルに合った期間と Privilege Points をお選びください。",
    tiers: {
      reserve: { name: "Reserve", years: "20年", desc: "招待制のみ。Privilege Points 付与数最大、家族会員制度、専任コンシェルジュを備えるフラグシップティア。", price: "THB 5,000,000" },
      diamond: { name: "Diamond", years: "15年", desc: "長期コミットメントに応える充実の年間 Privilege Points と家族会員オプション付き。", price: "THB 2,500,000" },
      platinum: { name: "Platinum", years: "10年", desc: "グローバルなエグゼクティブに人気のティア — 10年の長期居住とプレミアムコンシェルジュ＆Privilege Points。", price: "THB 1,500,000" },
      gold: { name: "Gold", years: "5年", desc: "コア特典とファストトラック空港サービス付きのエントリーレベル長期滞在ティア。更新可能。", price: "THB 900,000" },
      bronze: { name: "Bronze", years: "5年", desc: "最もアクセスしやすい Thailand Privilege Card ティア — 5年の長期居住と必須特典が揃ったプラン。", price: "THB 650,000" }
    },
    tiersLink: "タイランドエリートの全ティアを比較する",
    benefitsTitle: "タイランドエリート メンバーシップ特典",
    benefitsIntro: "Thailand Privilege Card が有効化された当日から利用できるもの — ビザ、サービス、タイランドエリート会員限定のアクセス権。",
    benefits: {
      longStay: { title: "5〜20年長期滞在ビザ", desc: "Thailand Elite Visa（Thailand Privilege Visa / Privilege Entry Visa とも称します）は、会員期間中に有効なマルチエントリー長期居住権を付与します。タイを出国することなく、入国ごとに更新が可能です。" },
      fastTrack: { title: "ファストトラック入国審査", desc: "Bangkok Suvarnabhumi、Phuket、Chiang Mai での専任パーソナルサービス — Elite Personal Assistant がゲートでお出迎えし、優先入国審査と手荷物受取を案内します。" },
      concierge: { title: "24時間 会員コンシェルジュ", desc: "Thailand Elite Member Contact Center を通じた政府・ライフスタイルコンシェルジュ — ビザ手続き、入国管理サポート、レストラン予約、翻訳など多岐にわたります。" },
      wellness: { title: "健康診断＆ウェルネス", desc: "タイ国内の国際水準病院での年次健康診断、パートナーリゾートにおける無料スパ＆ウェルネスパッケージ。" },
      lifestyle: { title: "ホテル、ゴルフ＆ライフスタイル", desc: "主要ホテルチェーンでの限定プロモーションや無料宿泊、ゴルフ場特典、VIPショッピングアクセス、厳選されたライフスタイル体験。" },
      noBorderRuns: { title: "ボーダーランが不要に", desc: "60日観光ビザや90日ごとのボーダーランは過去のものに。Thailand Privilege Card は、煩わしいビザ問題を一つの長期滞在ソリューションで解決します。" }
    },
    gssa: {
      badge: "認定 GSSA",
      title: "受賞歴ある公認チャンネルで申請",
      desc1: "Dreamond は Thailand Privilege Card Co., Ltd.（タイランドエリートプログラムの公式発行機関）の認定 Global Sales & Services Agent（GSSA）であり、国営機関のライセンス参照番号 SA21/012 を取得しています。公式認定パートナーとして、資格確認から身元審査、支払い調整、ビザ貼付まで申請プロセスを一貫してサポートします。費用は公式会員費用の上乗せなしです。",
      desc2: "当チームは50か国以上の数千名の会員をタイランドエリート申請に導いてきました。7言語対応、透明な料金体系、レビュープラットフォームでの評価 4.8/5 を誇ります。Bronze、Gold、Platinum、Diamond、Reserve のいずれにお申し込みの場合も、GSSA を通じることで単一の窓口と Thailand Elite スタッフへの直接アクセスが得られます。",
      tag1: "受賞歴あるサービス",
      tag2: "認定 GSSA（SA21/012）",
      tag3: "タイランドエリートへの直接チャンネル"
    },
    faqTitle: "Thailand Privilege Card — よくある質問",
    faqIntro: "Thailand Privilege Card、Thailand Elite Visa、ティア、申請方法についての最もよくある質問をまとめました。",
    faqs: {
      whatIs: { q: "Thailand Privilege Card とは何ですか？", a: "Thailand Privilege Card は、タイ唯一の会員制居住プログラム「タイランドエリート」の公式会員カードです。タイ観光スポーツ省傘下の国営機関である Thailand Privilege Card Co., Ltd. が発行します。会員は長期滞在ビザ（5〜20年）、ファストトラック入国審査、政府コンシェルジュ、ライフスタイル特典を受けられます。" },
      thailandElite: { q: "Thailand Privilege Card はタイランドエリートと同じですか？", a: "はい — 同一の公式プログラムを指します。タイランドエリートは2003年以来世界に認知されたプログラムブランドであり、Thailand Privilege Card Co., Ltd. はそのメンバーシップカードを発行・運営するタイの国営機関です。「タイランドエリート」と「Thailand Privilege Card」のどちらを参照しても、メンバーシップ・ビザ・特典の内容は同一です。" },
      tiers: { q: "タイランドエリート／Thailand Privilege Card のティアは何種類ありますか？", a: "5種類あります：Bronze（5年、THB 650,000）、Gold（5年更新可能、THB 900,000）、Platinum（10年、THB 1,500,000）、Diamond（15年、THB 2,500,000）、Reserve（20年、招待制、THB 5,000,000）。全ティアに Thailand Elite Visa と年間 Privilege Points 付与が含まれます。" },
      cost: { q: "Thailand Privilege Card の費用はいくらですか？", a: "Bronze 5年ティアが THB 650,000（約USD 18,000）から始まり、Reserve 20年招待制ティアは THB 5,000,000 です。費用は一回限りの会員費で、年次更新料は不要であり、ビザ費用も含まれています。" },
      validity: { q: "Thailand Privilege Card の有効期間はどのくらいですか？", a: "カードと付帯の Thailand Elite Visa は、選択したティアの全期間（5・10・15・20年）にわたって有効です。各入国で更新可能な1年間の滞在許可が付与されます。Gold 会員は5年ティアを更新可能ですが、他のティアは規定期間終了後に終了します。" },
      visa: { q: "Thailand Privilege Card で取得できるビザは何ですか？", a: "全会員に Thailand Elite Visa（Thailand Privilege Visa とも称し、公式には Privilege Entry Visa（PE）に分類）が付与されます。これはファストトラック入国審査付きのマルチエントリー長期滞在ビザで、会員期間全体にわたって有効であり、メンバーシップ終了まで無料で更新されます。" },
      howToApply: { q: "タイランドエリート／Thailand Privilege Card 会員の申請方法は？", a: "申請は100%オンラインで行えます。パスポートを提出し、会員申請フォームを記入して、身元審査（通常4〜12週間）に合格してください。支払いは承認後のみ発生します。認定 GSSA として、当社は公式会員費用の上乗せなしで、資格確認からビザ貼付まで全プロセスを代行します。" },
      gssa: { q: "GSSA とは何ですか？また、なぜ GSSA 経由で申請するのですか？", a: "Global Sales & Services Agent（GSSA）は、Thailand Privilege Card Co., Ltd. から正式に認定を受け、タイランドエリート会員申請の受付・処理を行うパートナーです。GSSA を通じて申請することで、英語対応の専任担当者によるサポート、書類準備支援、Thailand Elite スタッフへの直接エスカレーションチャンネルが利用でき、単独申請と費用は同一です。" },
      officialChannel: { q: "Dreamond はタイランドエリートの公式パートナーですか？", a: "はい。Dreamond は関係国営機関より参照番号 SA21/012 を取得した認定 Global Sales & Services Agent であり、50か国以上から数千名の承認会員を有し、7言語対応、主要レビュープラットフォームで 4.8/5 の評価を受けています。" },
      family: { q: "家族もタイランドエリートに加入できますか？", a: "はい。複数のティア（Gold Family、Platinum Family、Diamond Family、Reserve）には配偶者・両親・子供向けの家族会員制度が含まれており、それぞれが同一メンバーシップのもとで独自の Thailand Elite Visa を受け取れます。" }
    },
    relatedTitle: "タイランドエリートプログラムを探索する",
    related: { visa: "Thailand Elite Visa", points: "Privilege Points", bankAccount: "タイの銀行口座を開設する" },
    bottomCta: { title: "タイランドエリートに参加する準備はできましたか？", desc: "認定 GSSA のサポートのもとでタイランドエリート会員になりましょう。無料の資格確認、7言語対応、申請からビザスタンプまでの完全ガイダンス付き。", button: "今すぐタイランドエリートに申請する" }
  },
  privilegePoints: {
    metaTitle: "タイランドエリート・プリビレッジポイント – 限定特典を利用",
    metaDescription: "タイランドエリートのプリビレッジポイントについて — ラグジュアリーホテル、VIP送迎、スパ、ショッピング、資産アドバイザリーの限定サービスにポイントを利用。",
    badge: "プリビレッジポイントシステム",
    title: "プリビレッジポイント",
    subtitle: "無限の特典を選ぶ自由 — あなたにとって最も重要なサービスと体験にポイントを利用。",
    intro1: "<1>2023年10月に開始された新しいタイランド・プリビレッジ・カード会員プログラム</1>の特徴の一つは、各プログラムにメンバーが毎年利用できるプリビレッジポイントが付与されることです。",
    intro2: "プリビレッジポイントにより、本当に望むサービスや特典にアクセスする自由度が高まります。",
    intro3: "ポイントは毎年付与され、Stay、Travel、Leisure、Well-Being、Wealthの5つのカテゴリーで利用できます。",
    tableTitle: "メンバーシップティア別ポイント",
    tableSubtitle: "上位ティアほど多くの年間プリビレッジポイントが付与されます。",
    perYear: "年間",
    howItWorksTitle: "プリビレッジポイントの仕組み",
    howItWorksDesc: "ポイントは各メンバーシップ年の開始時に付与され、年間を通じて利用できます。未使用ポイントは繰り越されません。",
    compareButton: "メンバーシップティアを比較",
    privilegeBookButton: "プリビレッジブック 2026を見る",
    privilegeBookTitle: "プリビレッジブック 2026",
    openInNewTab: "新しいタブで開く",
    categories: {
      stay: { title: "Stay", description: "タイの最高のホテルやリゾートでの無料ホテルメンバーシップ、ボーナス宿泊、特別アメニティ。", items: ["主要ホテルチェーンの無料メンバーシップ", "パートナーホテルで1泊すると1泊無料", "提携ホテルでの特別アメニティ", "タイ全土の限定リゾート体験"] },
      travel: { title: "Travel", description: "空港でのVIP待遇、ラグジュアリーリムジン送迎、限定ラウンジアクセス。", items: ["エリートパーソナルアシスタントによる空港VIP出迎え", "ラグジュアリー車両での空港送迎", "主要空港での限定ラウンジアクセス", "プライベートジェット、航空会社、レンタカーの特別割引"] },
      leisure: { title: "Leisure", description: "VIPショッピング、コワーキングスペース、ワールドクラスのエンターテインメント。", items: ["主要ショッピングセンターでの特別割引", "プレミアムモールでのVIPラウンジアクセス", "パーソナルショッピングアシスタント", "プレミアムロケーションのコワーキングスペース", "ワールドクラスのコンサート＆イベントチケット", "主要シネマでのVIP上映"] },
      wellbeing: { title: "Well-Being", description: "ワールドクラスのヘルスケアとウェルネス。健康診断、フィットネス、スパパッケージ。", items: ["国際基準の病院での無料年間健康診断", "ホテルチェーンの無料フィットネスメンバーシップ", "プレミアムスパ＆ウェルネスパッケージ", "タイのトップウェルネスリトリートへのアクセス"] },
      wealth: { title: "Wealth", description: "資産アドバイザリー、ネットワーキングイベント、カスタマイズされた保険パッケージ。", items: ["資産＆投資アドバイザリーサービス", "限定ネットワーキングイベント＆セミナー", "駐在員向けの特別保険パッケージ", "金融＆法律相談への優先アクセス"] },
    },
  },
  guides: {
    metaTitle: "タイランドエリートガイド – ビザ・税金・銀行・タイでの生活",
    metaDescription: "タイランドエリート会員のための必須ガイド：滞在延長、税金、銀行口座、運転免許、TM30、90日届出、オーバーステイ、在留証明書。",
    badge: "会員ガイド",
    title: "タイ生活の必須ガイド",
    subtitle: "タイランドエリート会員が知っておくべきすべて — ビザ延長から税務計画、銀行、運転、行政手続きまで。",
    contactUs: "お困りですか？お問い合わせください",
    lastUpdated: "最終更新",
    readMore: "ガイド全文を読む",
    articles: {
      stayExtension: { shortTitle: "滞在延長", title: "タイランドエリートビザ保持者の1年滞在延長", summary: "タイを出国せずに1年以上滞在を延長する方法。必要書類、費用、手続き。", sections: [
        { heading: "入国スタンプの確認", content: "タイランドエリートビザ（PE）保持者は、5年間の更新可能なマルチエントリービザを持っています。入国の度に1年間の滞在許可が付与されます。\n\n入国スタンプを必ず確認してください。1年未満の場合は、直ちに入国管理官にお知らせください。" },
        { heading: "申請時期", content: "現在の滞在許可の30日前まで申請可能。費用は1,900バーツ（現金のみ）。" },
        { heading: "必要書類", content: "1. パスポート\n2. パスポートコピー2部（署名付き）\n3. 写真2枚（4×6cm）\n4. タイランドエリート会員カード\n5. TM30受領書\n6. TM7フォーム\n7. 1,900バーツ（現金）" },
        { heading: "重要な警告", content: "オーバーステイは深刻な法的結果をもたらします：罰金、拘留、強制送還、最大10年の入国禁止。" },
      ] },
      taxes: { shortTitle: "税金", title: "タイランドエリート会員のための税務ガイド", summary: "タイの税務居住者ルール、外国所得、二重課税防止条約。", sections: [
        { heading: "税務居住者 — 180日ルール", content: "暦年で180日以上タイに滞在すると税務居住者になります。" },
        { heading: "外国源泉所得", content: "2024年1月1日以降、タイ歳入局は外国源泉所得に関する解釈を更新しました。外国所得は、タイへ送金された場合にのみ、タイで課税対象となる可能性があります。このルールは、暦年で180日以上タイに滞在するタイ税務居住者にのみ適用されます。これは、すべての外国所得が自動的に課税されることを意味するものではありません。実務上は、タイ税務居住者がタイへ送金し、その人がタイ税務居住者となった後、または2024年1月1日以降に発生した外国源泉所得が対象となります。二重課税防止条約により、所得の種類や相手国に応じてタイでの課税が軽減または免除される場合もあります。年間のタイ滞在日数が180日未満であれば、外国所得は通常タイで課税されません。" },
        { heading: "タイランドエリートビザと税務計画", content: "タイランドエリートビザは観光ビザに分類され、就労許可は付与されません。" },
        { heading: "二重課税防止条約（DTA）", content: "タイは60カ国以上とDTAを締結しています。資格のあるタイの税務アドバイザーにご相談ください。" },
        { heading: "主な推奨事項", content: "1. タイでの滞在日数を正確に記録。\n2. すべての収入源と送金の記録を保管。\n3. 認定税務アドバイザーに相談。\n4. 送金のタイミングを考慮。\n5. DTAを活用。\n\n免責事項：情報提供のみを目的としています。" },
      ] },
      bankAccount: {
        shortTitle: "銀行口座",
        title: "エリート会員としてタイで銀行口座を開設",
        summary: "必要書類、提携銀行、口座の種類、EPL同行サービス——Thailand Privilege Card でタイの銀行口座を開設するための完全ガイド。",
        sections: [
          {
            heading: "エリート会員の利点",
            content: "Thailand Privilege Card 会員は、メンバーコンタクトセンターを通じて専属の口座開設サポートを受けられます。一般の旅行者がタイの銀行口座開設に苦労する一方、エリート会員は提携銀行（カシコン銀行、バンコク銀行、サイアム商業銀行 SCB、LH Bank）でスムーズな手続きをご利用いただけます。",
          },
        ],
        banks: {
          heading: "銀行別の必要書類",
          intro: "提携銀行ごとに必要書類が異なります。来店前に該当銀行のカードをご確認ください——可能な限り原本をご持参ください。",
          columns: { document: "必要書類", details: "詳細" },
          remarksLabel: "備考",
          items: [
            {
              name: "カシコン銀行 (Kasikorn Bank)",
              docs: [
                { document: "パスポート", details: "PE または SE ビザ付きパスポート" },
                { document: "Thailand Privilege 会員証明", details: "Thailand Privilege カードまたは TPC 会員確認のサティフィケートレター" },
                { document: "タイ国内の居住証明", details: "賃貸契約書、電気・水道料金請求書" },
                { document: "政府発行の身分証", details: "本国の国民ID、運転免許証、または住民登録" },
              ],
            },
            {
              name: "バンコク銀行 (Bangkok Bank)",
              docs: [
                { document: "有効なパスポート", details: "パスポート原本が必要" },
                { document: "Thailand Privilege ビザ", details: "非移民ビザ SE（Special Entry）または PE（Privilege Entry）" },
                { document: "Thailand Privilege 会員カード", details: "有効な Thailand Elite カード" },
                { document: "タイ国内の居住証明", details: "不動産所有書類、賃貸契約書、または最近の公共料金請求書" },
                { document: "連絡先電話番号", details: "タイの番号または連絡可能な電話番号が必要" },
                { document: "本国の身分証", details: "本国の住所が記載された国民IDまたは運転免許証（英語版または公証翻訳が必要）" },
                { document: "補足書類", details: "口座開設の理由を裏付ける追加の信頼できる書類1点" },
              ],
              remarks: [
                "ホテルの住所および私書箱の住所は受け付けません。",
                "原本書類が必要です。",
              ],
            },
            {
              name: "サイアム商業銀行 (SCB)",
              docs: [
                { document: "パスポート", details: "有効な Thailand Privilege PE または SE ビザ付きパスポート" },
                { document: "Thailand Privilege 会員カード", details: "会員カードが必要" },
                { document: "認証レター", details: "Thailand Elite による認証レター" },
                { document: "タイ国内の住所", details: "申請書類に必要" },
                { document: "タイの携帯電話番号", details: "インターネットバンキングに必要" },
                { document: "本国の身分証", details: "運転免許証または国民ID" },
              ],
            },
            {
              name: "LH Bank",
              docs: [
                { document: "パスポート", details: "Elite ビザシール付きパスポート（電子ビザは現在不可）" },
                { document: "Thailand Privilege 会員証明", details: "認証レターまたは TPC 会員カード" },
                { document: "本国の身分証", details: "運転免許証または国民ID" },
                { document: "タイの連絡先電話番号", details: "必須" },
                { document: "タイ国内の居住証明", details: "賃貸契約書、Tabian Baan（黄/青本）、または権利証" },
              ],
              remarks: ["ホテルの住所は受け付けません。"],
            },
          ],
        },
        accountTypes: {
          heading: "開設可能な口座の種類",
          columns: { type: "口座の種類", details: "詳細" },
          items: [
            { type: "普通預金口座", details: "0〜500 バーツから" },
            { type: "定期預金口座", details: "1,000 バーツから" },
            { type: "タイバーツおよび外貨預金口座 (FCD)", details: "利用可能" },
            { type: "口座維持手数料", details: "維持手数料なし" },
          ],
        },
        accountConditions: {
          heading: "口座条件",
          columns: { condition: "条件", scb: "SCB", kasikorn: "カシコン銀行", bangkok: "バンコク銀行" },
          items: [
            {
              condition: "初回最低預金額",
              scb: "500 バーツ",
              kasikorn: "500 バーツ",
              bangkok: "対象外",
            },
            {
              condition: "最低残高要件",
              scb: "2,000 バーツ",
              kasikorn: "2,000 バーツ",
              bangkok: "2,000 バーツ",
            },
            {
              condition: "月額維持手数料",
              scb: "12 か月間取引がなく残高 ≤ 2,000 バーツの場合、月額 50 バーツ",
              kasikorn: "12 か月間取引がなく残高 ≤ 2,000 バーツの場合、月額 50 バーツ",
              bangkok: "対象外",
            },
          ],
        },
        importantNotes: {
          heading: "重要事項",
          columns: { bank: "銀行", info: "手続き情報" },
          items: [
            { bank: "カシコン銀行", info: "承認前に書類審査に 7 日間を要します" },
            { bank: "バンコク銀行", info: "承認前に書類審査に 7 日間を要します" },
          ],
          footer: "承認後 1〜15 日以内に銀行に再来店して開設を完了する必要があります。会員カードがまだ届いていない場合は、認証レターでの代替が可能ですが、カシコン銀行と SCB に限ります。",
        },
        assistantService: {
          heading: "バンコクでの EPL 口座開設同行サービス",
          intro: "Elite Personal Liaison（EPL）チームが以下の支店で口座開設に同行いたします：",
          columns: { bank: "銀行", branch: "支店" },
          items: [
            { bank: "バンコク銀行", branch: "本店" },
            { bank: "カシコン銀行", branch: "Thanon Sathon 支店" },
            { bank: "SCB", branch: "Thanon Sathon 支店" },
            { bank: "LH Bank", branch: "Q House Lumpini" },
          ],
          remarksLabel: "備考",
          remarks: [
            "ご予約は 5 営業日前までにお願いします。",
            "本サービスはバンコク在住会員に限ります。",
            "EPL 同行サービスの初回は無料です。",
            "2 回目以降は 3,000 バーツまたは 2 ポイント（対象会員のみ）の手数料がかかります。",
          ],
        },
        faqs: {
          heading: "よくあるご質問",
          items: [
            {
              question: "会員カードが届いていなくても銀行口座を開設できますか？",
              answer:
                "はい。Elite ビザがパスポートに貼付済みであれば、普通預金口座（タイバーツまたは FCD）は実物の会員カードの代わりに Thailand Privilege 認証レターで開設できます。証券口座（株式）は引き続き会員カードが必要です。下表は口座種類および銀行別に必要書類をまとめたものです。",
              table: {
                columns: {
                  account: "口座の種類",
                  kasikorn: "カシコン銀行",
                  bangkok: "バンコク銀行",
                },
                items: [
                  {
                    account: "証券口座（株式）——決済口座",
                    kasikorn: "パスポート + 会員カード + 通帳",
                    bangkok: "パスポート + 会員カード + 通帳 + 納税者番号 (TIN)",
                  },
                  {
                    account: "普通預金口座（THB / FCD）——会員カードあり",
                    kasikorn: "パスポート + 会員カード",
                    bangkok: "パスポート + 会員カード",
                  },
                  {
                    account: "普通預金口座（THB / FCD）——会員カードなし",
                    kasikorn: "パスポート + 認証レター",
                    bangkok: "パスポート + 認証レター",
                  },
                ],
                footer:
                  "会員認証レターを添えて、3 営業日前までにメンバーコンタクトセンターまでサービスをお申し込みください。",
              },
            },
            {
              question: "バンコク銀行のクレジットカードを申し込むには？",
              answer:
                "最低 50,000 バーツの定期預金口座を開設する必要があります。この預金がクレジットカードの担保となります。",
            },
          ],
        },
        closing: "さらにサポートが必要な場合はお気軽にお問い合わせください。メンバーコンタクトセンターは 24 時間ご対応いたします。",
      },
      driving: { shortTitle: "運転免許", title: "タイで運転免許を取得する", summary: "タイの運転免許取得方法 — 要件、手続き、ヒント。", sections: [
        { heading: "国際運転免許証（IDP）", content: "有効なIDPで90日間タイで運転可能。90日後はタイの運転免許が必要です。" },
        { heading: "要件", content: "1. タイランドエリートビザ付きパスポート\n2. 在留証明書\n3. 健康診断書（約100バーツ）\n4. 母国の運転免許証\n5. 証明写真2枚" },
        { heading: "DLTでの手続き", content: "1. 書類を揃えてDLTオフィスへ。\n2. 色覚・反応テスト。\n3. 研修ビデオ（約1時間）。\n4. 筆記試験（英語対応）。\n5. 実技試験。\n6. 手数料：205バーツ（車）、105バーツ（バイク）。\n7. 2年間の仮免許、5年に更新可能。" },
      ] },
      adminDeclarations: { shortTitle: "行政手続き", title: "タイにおける外国人の行政届出", summary: "住所登録、納税者番号、公式届出などの行政要件。", sections: [
        { heading: "住所登録（TM30）", content: "全ての外国人は到着後24時間以内にTM30で住所を登録する必要があります。" },
        { heading: "納税者番号（TIN）", content: "タイで収入がある場合、歳入局からTINを取得する必要があります。" },
        { heading: "婚姻・出生届", content: "地区事務所（アンプー）で登録可能。書類はタイ語に翻訳し、大使館で認証する必要があります。" },
        { heading: "大使館登録", content: "タイの自国大使館に登録することをお勧めします。" },
      ] },
      tm30: {
        shortTitle: "TM30",
        title: "タイのTM30 — 外国人住所届出（2026年版 Thailand Eliteメンバー向けガイド）",
        summary: "Thailand Privilege Cardメンバーが知っておくべきTM30のすべて：届出義務者、ビザ貼付に必要なタイミング、在留証明書と90日届出との関係、家主登録の正確な手順、ステップバイステップ動画。",
        sections: [
          { heading: "Thailand Eliteメンバーへの簡単な回答", content: "TM30（外国人居住届出）は、あなたがタイに滞在を開始してから24時間以内に、家主・ホテル・物件所有者が入国管理局に提出しなければならないフォームです。\n\nコンドミニアムを賃借しているかホテルに滞在しているThailand Elite／Thailand Privilegeメンバーのほとんどは、家主やフロントデスクが届出を行います。あなたはTM30受領書を受け取るだけです。物件を自己所有している場合は、公式TM30ポータルに登録し、自分で届出を行う必要があります。\n\nTM30受領書が必要な場面：\n• Chaeng Wattana（チェーンワッタナー）入国管理局でのThailand Privilegeビザステッカーの貼付\n• 在留証明書の申請\n• 90日届出（TM47）の提出 — TM30に記載の住所が一致していなければなりません\n• 年次滞在延長または再入国許可の申請\n\n実務上、同一住所に滞在し続ける場合、年に1回のTM30届出で十分なことがほとんどです — タイを出国したり住所を変更したりしない限り。" },
          { heading: "TM30とは？", content: "TM30は、タイ移民法B.E. 2522（1979年）第38条に基づく法定届出です。入国管理局に各外国人のタイ国内における現在の居住地を通知するものです。\n\n届出義務は物件の所有者または居住管理者にあり、外国人本人ではありません。Thailand Eliteメンバーは、家主が実際に届出を完了しているかを確認する必要があります。TM30受領書は、ビザ貼付・在留証明書・90日届出・滞在延長など、ほぼすべての入国管理手続きで必要となるためです。" },
          { heading: "タイでTM30の届出義務があるのは誰か？", content: "法律上、届出義務は物件所有者または「家主」にあり、外国人本人ではありません。対象となるのは以下の方々です。\n\n• ホテルおよびサービスアパートメント — チェックイン時に自動的に届出されます。フロントを離れる前にTM30受領書を必ず受け取ってください。\n• 家主（コンドミニアムまたは一戸建て賃貸） — 到着後24時間以内に届出が必要です。PDF受領書を必ず受け取ってください。\n• 物件所有者 — 自己所有のコンドミニアム、ビラ、一戸建てに居住する場合は、TM30ポータルに登録し、自分で届出を行う必要があります。\n• 外国人を受け入れる知人・家族 — 無償の場合でも、一晩でも泊まるタイ国籍でないゲストのためにTM30を届出する法的義務があります。\n\n有効なTM30なしで物件が外国人を受け入れた場合、物件所有者は最大10,000バーツの罰金を科される可能性があります。外国人も、届出が行われなかった場合に最大2,000バーツの罰金を科される可能性があります。" },
          { heading: "TM30の登録方法（家主およびThailand Elite自己所有者向け）", content: "タイに物件を自己所有している場合は、届出を行う前にTM30ポータルのアカウントを作成する必要があります。登録はすべてオンラインで行い、約10分で完了します。\n\n公式ポータル：\nhttps://tm30.immigration.go.th/tm30//#/external/security/register\n\nステップバイステップ動画チュートリアル：\nhttps://youtu.be/fqZd7B1ub5A\n\n登録に必要なもの：\n• 有効なThailand Privilegeビザ（PEまたはSE）付きのパスポート\n• 所有権証明 — Chanote（タイトルディード）、コンドミニアム権利証、または家屋登録書（Tabian Baan）\n• OTP受信用のタイの携帯電話番号\n• 有効なメールアドレス\n\n承認には通常1〜2営業日かかります。アカウントが有効になると、外国人（自分自身を含む）が物件に入居または再入居するたびにTM30を提出できます。" },
          { heading: "外国人のTM30提出方法", content: "家主アカウントが有効になれば、TM30の提出は簡単です。\n\n1. TM30ポータルにログインします。\n2. 「外国人居住届出」をクリックし、ゲストのパスポート情報（番号、国籍、到着日、出発予定日）を入力します。\n3. 住所を確認 — アカウントに登録されている物件と一致している必要があります。\n4. 提出します。システムが参照番号付きのPDF受領書を生成します。\n5. PDFを保存し、外国人にコピーを転送してください — 以降のすべての入国管理手続きで必要となります。\n\n外国人がタイに再入国するたびに、同じ住所に戻る場合でも、新しいTM30を提出しなければなりません。24時間のカウントは、元の賃貸開始日ではなく、再入国のたびにリセットされます。" },
          { heading: "Thailand Elite／Privilegeメンバーがいつ TM30が必要か", content: "TM30は、タイ入国管理局とのほぼすべてのやり取りにおける基本書類です。以下の場合に有効で最新のTM30受領書が必要となります。\n\n• Thailand Privilegeビザの貼付 — バンコク、Chaeng Wattana（チェーンワッタナー）Government ComplexにあるImmigration Division Iのオフィスで。担当官はビザステッカーを発行する前にTM30受領書を求めます。\n• 在留証明書の申請 — 運転免許証の取得、車両・コンドミニアムの購入、銀行口座の開設などに使用する証明書の発行に、最新のTM30が必要です。詳細な手続きについては在留証明書ガイドをご参照ください。\n• 90日届出（TM47）の提出 — 90日届出に記載の住所は、最新のTM30に記載の住所と一致している必要があります。オンラインTM47申請が却下される最も多い理由がこれです。\n• 年次滞在延長または再入国許可の申請。\n\n年間を通じて同じ登録住所に滞在し、海外に出かけない場合は、通常TM30は1回で十分です。実際には、ほとんどのEliteメンバーは海外渡航後に年1〜2回再届出を行っています。" },
          { heading: "90日届出が却下される理由とTM30による解決策", content: "オンラインTM47 90日届出が繰り返し却下される場合、最も可能性が高い原因はTM30の住所不一致です。\n\n• 別の府県に旅行した（例：Chiang MaiやPhuketのホテルに滞在）。\n• そのホテルが最新の登録居住地としてホテルの住所でTM30を届出した。\n• バンコクの自宅住所から90日届出を提出しようとすると、2つの住所が一致しなくなり、システムが却下する。\n\n解決策：バンコクの家主（または自己所有の場合は自分自身）に、帰宅日付けで新しいTM30を届出してもらってください。最新のTM30の住所が90日届出の住所と一致すれば、TM47はオンラインで通過します。\n\n家主が対応しない場合は、Thailand Elite Member Contact Centerが新たな届出の調整をサポートできます。" },
          { heading: "TM30の不遵守に対する罰則", content: "• 物件所有者／家主 — 最大10,000バーツの罰金。\n• 外国人（届出が行われなかった場合） — 最大2,000バーツの罰金。\n• 実務上の影響 — 有効なTM30がなければ、90日届出の提出、Eliteビザの貼付、在留証明書の取得、滞在延長のいずれもできません。届出が記録されるまで、入国管理官に対応を断られます。\n\nすべてのTM30届出のPDF受領書をスマートフォンの専用フォルダに保管してください — 想定以上に頻繁に提示を求められます。" }
        ],
        faqs: {
          heading: "TM30 — よくある質問",
          items: [
            { question: "タイでTM30の届出義務があるのは誰ですか？", answer: "法律上、物件所有者・家主・ホテル・「家屋主」がTM30を提出する責任があります。外国人本人ではありません。ホテルはチェックイン時に自動的に届出します。家主は到着後24時間以内に届出しなければなりません。タイに自己所有の住居がある場合は、TM30ポータルに登録し、自分で届出する必要があります。" },
            { question: "物件所有者としてTM30に登録するにはどうすればよいですか？", answer: "https://tm30.immigration.go.th/tm30//#/external/security/register の公式ポータルでアカウントを作成します。有効なThailand Privilegeビザ付きのパスポート、所有権証明（Chanote、コンドミニアム権利証、またはTabian Baan）、OTP受信用のタイの携帯電話番号、メールアドレスが必要です。承認には通常1〜2営業日かかります。ステップバイステップの動画解説が https://youtu.be/fqZd7B1ub5A でご覧いただけます。" },
            { question: "Thailand Elite／Thailand PrivilegeメンバーはいつTM30受領書が必要ですか？", answer: "Chaeng Wattana（チェーンワッタナー）入国管理局でのThailand Privilegeビザの貼付、在留証明書の申請、90日TM47届出の提出、年次滞在延長または再入国許可の申請の際に、有効なTM30受領書が必要です。" },
            { question: "オンラインの90日届出（TM47）が却下され続けるのはなぜですか？", answer: "最も多い原因はTM30の住所不一致です。旅行中に別の府県のホテルがあなたの最新の登録居住地としてTM30を届出した場合、自宅住所が90日届出の住所と一致しなくなります。自宅の家主（または自己所有の場合は自分自身）に、帰宅日付けで新しいTM30を提出してもらってください — 住所が一致すれば、TM47の提出が成功します。" },
            { question: "Thailand EliteメンバーはどのくらいのペースでTM30を届出する必要がありますか？", answer: "法律上、物件への入居または再入居のたびに24時間以内にTM30を届出しなければなりません。実際には、タイを出国せずに同じ住所に滞在し続ける場合は1回で十分です。ほとんどのEliteメンバーは海外渡航後に年1〜2回再届出しています。" },
            { question: "家主がTM30の届出を拒否または忘れた場合はどうすればよいですか？", answer: "家主は最大10,000バーツの罰金を科される法的責任があり、届出が行われなかった場合あなたも最大2,000バーツの罰金を科される可能性があります。さらに重要なのは、90日届出の提出、Eliteビザの貼付、在留証明書の取得ができなくなることです。Thailand Elite Member Contact Centerにご連絡ください — 要求のエスカレーションや代替届出の手配をサポートできます。" }
          ]
        },
        videoUrl: "https://youtu.be/fqZd7B1ub5A",
        videoTitle: "TM30ポータルへの登録方法 — ステップバイステップ（Thailand Eliteメンバー向け）",
        registerUrl: "https://tm30.immigration.go.th/tm30//#/external/security/register",
        labels: {
          watchVideo: "登録手順の動画を見る",
          openPortal: "公式TM30ポータルを開く",
          relatedHeading: "関連ガイド",
          residenceCertLink: "タイでの在留証明書の取得"
        }
      },
      annualExtension: { shortTitle: "年次延長", title: "タイランドエリート会員の年次ビザ延長", summary: "タイを出国せずに年間滞在許可を更新する方法。", sections: [
        { heading: "なぜ必要か", content: "ビザが5〜20年有効でも、各入国で最大1年の滞在許可のみ。1年以上滞在する場合は年次延長が必要です。" },
        { heading: "申請時期", content: "有効期限の30日前まで。少なくとも2週間前の申請を推奨。" },
        { heading: "手続き", content: "1. 必要書類を準備。\n2. 入国管理局を訪問。\n3. TM7フォームを提出。\n4. 1,900バーツを現金で支払い。\n5. 写真撮影と指紋採取。\n6. 新しい延長スタンプを取得。" },
      ] },
      ninetyDays: {
        shortTitle: "90日届出",
        title: "TM47フォーム — タイにおける90日届出の完全ガイド2026（Thailand Eliteメンバー向け）",
        summary: "Thailand Elite / Thailand Privilege メンバーが知っておくべきTM47フォームとタイの90日届出に関するすべての情報。TM47とは何か、記入方法、オンライン・対面・郵送・Bangkok/Pattaya/Phuket/Chiang Maiのエリートドロップオフサービスによる提出方法、さらに罰則とTM47却下時の対処法まで解説します。",
        sections: [
          {
            heading: "TM47フォーム / 90日届出 — Thailand Eliteメンバーへの要点説明",
            content: "TM47は、タイに90日以上継続して滞在するすべての外国人が現住所を届け出るために提出する、タイ入国管理局の公式フォームです。TM47フォームはビザを延長するものではなく、Thailand Elite / Thailand Privilege メンバーを含む長期滞在者全員に求められる定期的な住所確認手続きです。\n\nTM47の提出方法は4つあります。\n• 公式ポータルからオンライン — 無料。届出期日の15日前から7日後まで利用可能。\n• 登録住所を管轄する入国管理局へ直接持参（TM47紙フォームは現地で配布）。\n• 書留郵便による郵送（紙のTM47フォームを期日の少なくとも15日前に送付）。\n• Bangkok、Pattaya、Phuket、Chiang Maiの Thailand Elite ドロップオフサービスを利用 — 当社スタッフがお客様に代わって入国管理局にTM47フォームを提出します。\n\n90日カウンターはタイを出国して再入国するたびにリセットされます。そのため海外へ旅行される会員は年に1〜2回しか届出が不要なケースがほとんどです。期日から7日を超えた遅延提出にはTHB 2,000の罰金が科され、一切届出をしなかった場合は最大THB 5,000の罰金に加え、次回の入国管理手続きでも支障が生じる可能性があります。",
          },
          {
            heading: "TM47 90日届出とは？",
            content: "TM47は、タイ入国管理法（B.E. 2522年 / 1979年）第37条（5）に基づく法的届出義務です。タイに90日以上継続して滞在する外国人は、現住所を入国管理局に届け出る必要があり、在留中は以降も90日ごとに継続して届け出なければなりません。\n\nTM47はビザの有効期限とは無関係であり、滞在期間を延長するものでもありません。純粋に住所確認のための行政手続きであり、入居時に家主が届け出るTM30とは別のものです。両者の違いについてはTM30ガイドをご参照ください。",
          },
          {
            heading: "TM47の届出義務がある方は？",
            content: "タイで長期滞在ビザを取得している外国人が90日継続滞在の閾値を超えた場合、TM47の届出が必要です。対象となる方は以下の通りです。\n\n• Thailand Elite / Thailand Privilege Visa 保持者（PE および SE）\n• 退職ビザ保持者（Non-OA / Non-OX）\n• 婚姻ビザ保持者（Non-O）\n• 就労許可保持者（Non-B）\n• 教育ビザ保持者（Non-ED）\n• Long-Term Resident（LTR）ビザ保持者\n\n観光客や短期滞在者は許可滞在期間が90日継続に達することが少ないため、通常はTM47の対象となりません。理由を問わずタイを出国した場合、たとえ週末の短い旅行であっても、再入国時に新たな90日カウンターが開始されます。",
          },
          {
            heading: "90日届出の期日は？",
            content: "最初のTM47届出は継続滞在の90日目が期日です。以降は90日ごとにサイクルが繰り返されます。入国管理局は柔軟な届出窓口を設けています。\n\n• 最も早く提出できる日：期日の15日前\n• 罰金なしで提出できる最終日：期日の7日後\n• 7日後以降：THB 2,000の罰金が科され、次回の延長やビザ貼付の際にも実務的な支障が生じます。\n\nタイを出国して再入国した場合、90日カウンターは新しい入国日からリセットされます。どの期間の旅行に対してもTM47は不要であり、90日以上の継続滞在が発生した場合にのみ提出が必要です。\n\nThailand Eliteメンバーは Member Contact Center に期日の管理とリマインダーの送付を依頼できます。コンシェルジュサービスをご利用の会員については自動的に対応いたします。",
          },
          {
            heading: "TM47フォームのオンライン記入・提出方法",
            content: "オンライン提出は無料で24時間365日利用可能であり、Bangkok在住またはその他の地域に滞在するThailand Eliteメンバーに最も多く利用されている方法です。公式TM47オンラインポータルはタイ入国管理局が運営しています。\n\n公式TM47オンラインポータル：https://tm47.immigration.go.th/tm47/\n\nTM47フォームのオンライン記入に必要な情報：\n• パスポートのデータページに記載された通りのパスポート番号および個人情報\n• 最新のビザ入国日（最も新しい入国スタンプをご確認ください）\n• タイの現住所 — 最新のTM30に登録されている住所と一致していること\n• PDFの受領書送付のための有効なメールアドレス\n• 任意：参照用として前回の90日届出受領書\n\nTM47をオンラインで記入・提出するステップ：\n1. ポータルを開きログインします（初めての方はパスポートとメールで登録してください）。\n2. 氏名・国籍・パスポート番号・生年月日などの個人情報を確認します。\n3. ビザ情報と最新の入国日を入力します。\n4. タイの現住所を入力します（TM30と丁目・区・郵便番号まで正確に一致していること）。\n5. すべての項目を慎重に確認してください。誤字や住所の不一致が却下の最大の原因です。\n6. 確認して送信します。\n7. PDF受領書をダウンロードし、スマートフォンの専用フォルダに保存してください。次回のビザ貼付・在留証明書・延長手続きの際に提示を求められます。\n\n処理は通常即時完了します。ポータルがエラーを返した場合は次のセクションをご参照ください。",
          },
          {
            heading: "TM47オンライン申請が却下される理由と対処法",
            content: "オンラインTM47が却下される最も一般的な理由は、TM30の住所との不一致です。ポータルは入力された住所を最新のTM30（家主が提出した住所届出）と照合します。完全に一致しない場合、システムはエラーを返します。\n\n典型的なケース：\n• 別の府へ旅行した際にホテルがお客様のTM30を届け出たため、そのホテルの住所が最新の登録住所となっており、自宅住所と一致しない。\n• タイへの最新の再入国後、家主が新しいTM30を届け出るのを忘れた。\n• 転居先住所がまだ届出されていない。\n\nいずれの場合も、届出したい住所について有効なTM30が登録されていることを確認することが解決策です。家主（またはご自身が物件を所有している場合はご自身）に新しいTM30を提出するよう依頼してください。一度システムに反映されれば、TM47のオンライン申請が通るようになります。TM30の登録手順については TM30ガイドをご参照ください。\n\nTM30を修正した後もポータルが引き続き失敗する場合、Member Contact Center がお客様に代わって入国管理局への手動申請を調整することができます。初めて届出を行う会員の方に特に有用です。",
          },
          {
            heading: "TM47の対面・郵送での申請",
            content: "オフラインでの届出をご希望の場合、2つの方法があります。\n\n対面 — 登録住所を管轄する入国管理局に出向いてください。持参するものは、パスポート（原本および写真ページ・ビザページ・最新の入国スタンプのコピー）、最新のTM30受領書、記入済みのTM47フォーム（窓口で配布）、前回の90日届出受領書（お持ちの場合）です。ウォークインを受け付けている事務所もありますが、混雑した事務所（Bangkok の Chaeng Wattana（チェーンワッタナー）など）は午前中の早めの到着をお勧めします。\n\n郵送 — TM47フォームをダウンロードして記入し、パスポートの各ページのコピーとTM30受領書を同封の上、管轄の入国管理局宛てに書留郵便で送付してください。スタンプ済みの返信用封筒を同封すると、スタンプされた受領書が送り返されます。郵送での申請は期日の少なくとも15日前に届くよう送付してください。重要なのは配達到着時の消印であるため、追跡を必ずご確認ください。\n\n実際には、Thailand Eliteメンバーが郵送を利用することはほとんどありません。オンラインポータルまたは Elite ドロップオフサービスの方が迅速かつ簡単です。",
          },
          {
            heading: "Thailand Elite ドロップオフサービス — Bangkok、Pattaya、Phuket、Chiang Mai",
            content: "Thailand Elite メンバーは90日届出書類を当社スタッフに預けていただければ、入国管理局への提出をすべてお任せいただけます。週に設定された特定の日に4都市でドロップオフサービスを提供しています。パスポート（またはコピー）と最新のTM30受領書を該当の場所へお持ちいただくと、1〜2営業日以内にスタンプ済みのTM47受領書をお返しします。\n\n費用不要、並ぶ手間なし、ポータル却下の心配もありません。予約は Member Contact Center を通じて少なくとも24時間前に行ってください。現在の日程・住所・時間については下記の表をご参照ください。",
          },
          {
            heading: "TM47の遅延・未届出に対する罰則",
            content: "• 遅延提出（期日から7日超）：次回の入国管理手続き時にTHB 2,000の罰金。\n• 一度も届出していない状態で発覚した場合（空港での出国時や延長申請時など）：最大THB 5,000の罰金。\n• 繰り返し不遵守の場合、将来のビザ延長・再入国許可・在留証明書の申請に支障が生じる可能性があります。\n\nTM47の未届出による前科やビザ取消しはありませんが、入国管理官が記録し、それ以上の手続きを進める前に現金での罰金支払いが必要となります。継続滞在の75日目にカレンダーリマインダーを設定するか、Member Contact Center に追跡をお任せください。",
          },
        ],
        faqs: {
          heading: "TM47フォーム / 90日届出 — よくある質問",
          items: [
            {
              question: "タイにおけるTM47とは何ですか？",
              answer: "TM47は90日届出に使用するタイ入国管理局の公式フォームです。タイに90日以上継続して滞在するすべての外国人は、TM47を記入して入国管理局に現住所を届け出る必要があり、以降も90日ごとに継続して提出しなければなりません。TM47はThailand Elite / Thailand Privilege Visa、退職・婚姻・就労・教育・LTRビザを含むすべての長期滞在ビザに適用されます。",
            },
            {
              question: "TM47フォームとは何ですか？",
              answer: "TM47フォーム（タイ王国90日以上滞在届出書）は、外国人がタイ入国管理局に提出する住所届出書類です。すべての入国管理局で紙フォームとして、また https://tm47.immigration.go.th/tm47/ の公式ポータルでデジタルフォームとして入手できます。TM47フォームはビザを延長するものではなく、純粋に住所確認のためのものです。提出後にはパスポートと一緒に保管するためのスタンプ済み受領書が発行されます。",
            },
            {
              question: "TM47フォームはどのように記入しますか？",
              answer: "紙のTM47フォームには、氏名・国籍・パスポート番号、タイへの最新入国日およびビザ種別（Thailand Eliteメンバーの場合は Privilege Entry Visa）、タイの現住所（最新のTM30と一致していること）、電話番号および署名を記入してください。公式ポータルからのオンライン申請では、可能な範囲で前回の届出内容がプリフィルされます。住所は必ず再確認してください。TM30との不一致がTM47却下の最大の原因です。オンラインの詳細な手順については上記のステップバイステップセクションをご参照ください。",
            },
            {
              question: "TM47フォームはどこからダウンロードできますか？",
              answer: "紙のTM47フォームはすべてのタイ入国管理局で無料で配布されており、事前にダウンロードや印刷をする必要はありません。郵送で提出する場合は、入国管理局のウェブサイト（https://www.immigration.go.th）からダウンロードすることもできます。オンライン申請の場合は、公式TM47ポータル https://tm47.immigration.go.th/tm47/ をご利用ください。このフローではPDFダウンロードの手順はありません。",
            },
            {
              question: "TM47 90日届出とは何ですか？",
              answer: "TM47 90日届出は、本ガイド全体を通じて言及されている書類と同じもの、すなわち「タイ王国90日以上滞在届出書」です。タイ入国管理法第37条（5）に基づき義務付けられており、Thailand Elite / Thailand Privilege メンバーを含むすべての長期滞在ビザ保持者に適用されます。ビザを延長するものではなく、純粋に住所確認のための手続きです。",
            },
            {
              question: "TM47をオンラインで申請するにはどうすればよいですか？",
              answer: "公式TM47オンラインポータル https://tm47.immigration.go.th/tm47/ にアクセスし、パスポートとメールアドレスで登録し、現住所（最新のTM30と一致していること）を確認して送信してください。処理は通常即時完了し、PDFの受領書をダウンロードしてスマートフォンに保存できます。オンライン申請は無料で、期日の15日前から7日後まで利用可能です。",
            },
            {
              question: "TM47のオンライン申請が却下されるのはなぜですか？",
              answer: "最も一般的な原因はTM30の住所との不一致です。たとえば、最近の旅行中に別の府のホテルがお客様のTM30を届け出たため、そのホテルの住所が最新の登録住所となっているケースが考えられます。自宅の家主（またはご自身が物件を所有している場合はご自身）に自宅住所で新しいTM30を提出するよう依頼し、その後TM47の申請を再試行してください。詳しい手順については TM30ガイドをご参照ください。",
            },
            {
              question: "Thailand Elite / Thailand Privilege メンバーもTM47を提出する必要がありますか？",
              answer: "はい。TM47はビザ種別に関わらず、タイに90日以上継続して滞在するすべての外国人に適用されます。Thailand Eliteメンバーは、Bangkok、Pattaya、Phuket、Chiang Mai で当社スタッフがお客様に代わって届出を提出するドロップオフサービスを含むコンシェルジュサポートをご利用いただけます。",
            },
            {
              question: "90日経つ前にタイを出国した場合はどうなりますか？",
              answer: "90日カウンターはタイを出国して再入国するたびにリセットされます。短期の海外旅行をした場合、その滞在についてTM47を提出する必要はなく、次の入国日から新しい90日カウンターが始まります。海外旅行をするThailand Eliteメンバーの多くは年に1〜2回しかTM47を提出しません。",
            },
            {
              question: "TM47の遅延提出に対する罰金はいくらですか？",
              answer: "期日から7日を超えた場合はTHB 2,000の罰金です。一度も提出していない状態で発覚した場合（空港での出国時や延長申請時など）は、罰金がTHB 5,000に上がることがあります。罰金は入国管理局で現金で支払う必要があり、支払いが完了するまで他の手続きは進められません。",
            },
            {
              question: "TM47を早めに提出できますか？",
              answer: "はい。届出窓口は正式な期日の15日前に開き、罰金なしで早めに提出することができます。Thailand Eliteメンバーの多くは、タスクを早期に完了させ、次の旅行に備えて受領書を手元に用意しておくために、窓口が開いてすぐに提出しています。",
            },
            {
              question: "TM47の提出に必要な情報は何ですか？",
              answer: "パスポートの詳細情報、最新のビザ入国日、タイの現住所（最新のTM30と一致していること）、PDFの受領書を受け取るための有効なメールアドレスが必要です。前回の90日届出受領書をお持ちの場合は参照用として手元に置いておいてください。TM6出国カードの番号は現在不要です（廃止されています）。",
            },
          ],
        },
        onlineUrl: "https://tm47.immigration.go.th/tm47/",
        labels: {
          openOnlinePortal: "公式TM47ポータルを開く",
          eplHeading: "Thailand Elite ドロップオフサービス",
          eplIntro: "いずれかの都市でパスポートのコピーと最新のTM30受領書を当社スタッフにお渡しいただければ、お客様に代わって入国管理局にTM47を提出いたします。予約は Member Contact Center を通じて少なくとも24時間前に行ってください。",
          eplColumns: {
            city: "都市",
            address: "事務所 / ドロップオフ拠点",
            schedule: "スケジュール",
          },
          methodsHeading: "TM47提出方法の比較",
          methodsColumns: {
            method: "方法",
            timing: "所要時間",
            availability: "最適な利用シーン",
          },
          relatedHeading: "関連ガイド",
          tm30Link: "TM30 — 外国人住所届出",
          annualExtensionLink: "年次滞在延長",
          residenceCertLink: "在留証明書の取得",
        },
        eplLocations: [
          {
            city: "Bangkok",
            address: "Thailand Elite本部、Sathorn Road",
            schedule: "毎週火曜日 16:30まで",
          },
          {
            city: "Pattaya",
            address: "Thailand Elite Pattaya地域事務所",
            schedule: "要予約（月〜金）",
          },
          {
            city: "Phuket",
            address: "Thailand Elite Phuket地域事務所",
            schedule: "要予約（月〜金）",
          },
          {
            city: "Chiang Mai",
            address: "Thailand Elite Chiang Mai地域事務所",
            schedule: "要予約（月〜金）",
          },
        ],
        methods: [
          {
            method: "オンライン（TM47ポータル）",
            timing: "即時",
            availability: "最速の方法 — TM30が最新であること",
          },
          {
            method: "Thailand Elite ドロップオフ",
            timing: "1〜2営業日",
            availability: "Bangkok、Pattaya、Phuket、Chiang Maiの会員",
          },
          {
            method: "入国管理局への直接持参",
            timing: "当日",
            availability: "誰でも — ポータルが却下された場合に有用",
          },
          {
            method: "書留郵便",
            timing: "15日以上前に届く必要あり",
            availability: "ポータルが使えない遠隔地の会員",
          },
        ],
      },
      overstays: { shortTitle: "オーバーステイ", title: "入国規制とオーバーステイの結果", summary: "オーバーステイの罰則、入国規制、コンプライアンスの維持方法。", sections: [
        { heading: "入国規制", content: "タイランドエリート会員は全ての国際入国ポイントから入国可能。会員期間中の無制限マルチエントリー。" },
        { heading: "オーバーステイの罰則", content: "• 1日500バーツ（最大20,000バーツ）。\n• 90日超：1年間の入国禁止。\n• 1年超：3年間禁止。\n• 3年超：5年間禁止。\n• 5年超：10年間禁止。" },
        { heading: "オーバーステイを避けるには", content: "1. 入国スタンプを確認。\n2. 45日前にリマインダー設定。\n3. 期限前に延長。\n4. 不明な場合はコンタクトセンターへ。\n5. 延長不可の場合は出国して再入国。" },
      ] },
      residenceCert: {
        shortTitle: "在留証明書",
        title: "タイでの在留証明書の取得",
        summary: "運転免許、銀行口座開設などに必要な公式在留証明書を入国管理局から取得する方法。",
        sections: [
          { heading: "タイの在留証明書 — 要点", content: "在留証明書（Certificate of Residence）は、タイ入国管理局がタイ国内に登録された現住所を証明するために発行する公式書類です。費用は500バーツで、取得には通常1〜3営業日かかりますが、当日発行する事務所もあります。タイに合法的に居住する外国人が銀行口座開設、タイの運転免許取得、車両登録、または不動産購入を行う際に必要となります。この書類は「居住証明書」や「住所確認書」とも呼ばれ、タイの機関が外国人に対して認める標準的な住所証明書類です。" },
          { heading: "在留証明書とは？", content: "在留証明書（Certificate of Residence、または Address Verification Letter とも呼ばれます）は、タイ入国管理局が発行する、タイ国内での現登録住所を証明する公式書類です。\n\n重要な区別として、在留証明書は居住許可（Residence Permit）とは異なります。居住許可（永住権）は取得が非常に困難な別の在留資格であり、タイへの無期限在留権を付与します。在留証明書はあくまで住所確認書類であり、いかなる在留資格や滞在権も付与しません。観光ビザや短期滞在者は原則として発行対象外です。有効な長期滞在ビザを持ち、証明対象住所に現在の TM30 が登録されている外国人に対してのみ発行されます。" },
          { heading: "在留証明書を取得できる人は？", content: "有効な長期滞在ビザを持ち、当該住所に現在の TM30（住所届出）が登録されているすべての外国人が申請できます。対象となるビザカテゴリは以下の通りです：\n\n• Thailand Elite / Thailand Privilege 会員（PE または SE ビザ）\n• 退職ビザ保持者（Non-OA / Non-OX）\n• 婚姻ビザ保持者（Non-O）\n• 就労許可保持者（Non-B）\n• 教育ビザ保持者（Non-ED）\n• Long-Term Resident（LTR）ビザ保持者\n\n観光ビザや無査証入国の方は原則として対象外です。入国管理局は安定した長期滞在の実態を要件としているためです。" },
          { heading: "在留証明書が必要な場面", content: "タイの銀行、政府機関、不動産登記所は、外国人に対する標準的な住所証明として在留証明書を使用します。主な必要場面は以下の通りです：\n\n• タイの銀行口座開設 — 主要銀行（Bangkok Bank、Kasikorn、SCB など）は外国人に対して必要とすることが多い。詳細は銀行口座開設ガイドをご参照ください。\n• 陸運局（DLT）でのタイ運転免許取得 — パスポートおよび健康診断書とともに必要。詳細は運転免許ガイドをご参照ください。\n• 陸運事務所でのご自身名義での車両・バイク登録。\n• 土地局（Land Department）でのコンドミニアム購入または長期リース登録。\n• タイ税関を通じた海外からの個人車両輸入。\n• 区役所（Amphoe）での婚姻・離婚届出、子供の学校入学、改名手続き。\n• タイの住所確認書類が必要な生命保険や投資口座の開設。" },
          { heading: "在留証明書の取得場所", content: "在留証明書はタイ入国管理局が発行します。バンコクの主要事務所は以下の通りです：\n\n入国管理局第1部門、政府庁舎 Building B、Chaeng Wattana（チェーンワッタナー）道路、Bangkok 10210\n（月〜金 08:30〜16:30 営業、祝日休み）\n\nバンコク以外では、TM30 が登録されている地方の入国管理局事務所でも申請できます。\n\n注意点として、一部の外国大使館は自国民向けに独自の住所証明書（「居住証明書」などと呼ばれる場合があります）を発行することがあります。本国当局との手続きには有用ですが、この大使館発行の書類は、タイの銀行、陸運局、不動産登記の手続きにおいて、タイ入国管理局が発行する在留証明書の代替としては一般的に受け付けられません。" },
          { heading: "取得手順 — ステップバイステップ", content: "1. TM30 が最新であることを確認 — 入国管理局は、証明する住所の住所届出が登録・最新状態であるかを確認します。未登録または期限切れの場合は、先に新しい TM30 を届け出てください（TM30 ガイドを参照）。\n2. 必要書類を準備します（次のセクションを参照）。\n3. 月曜日〜金曜日の 08:30〜16:30（昼休み 12:00〜13:00）に入国管理局を訪問します。Chaeng Wattana は混雑することがあるため、早めに到着することをお勧めします。\n4. 案内カウンターで申請書を受け取り、記入します（申請書は窓口で配布されているため、持参する必要はありません）。\n5. 書類を該当カウンターに提出します。\n6. 500バーツを現金で支払います（カード不可の事務所がほとんどです）。\n7. 証明書を受け取ります。当日発行する事務所もありますが、1〜3営業日かかる場合もあります。提出時にスタッフに受け取り方法を確認してください。\n\n証明書の有効期限は発行日から通常30日間ですが、一部の機関（特に銀行）は発行から90日以内のものを受け付ける場合があります。提出先機関に事前に確認することをお勧めします。" },
          { heading: "必要書類", content: "原本とコピーを両方ご持参ください：\n\n• 有効な Thailand Privilege Visa（PE または SE スタンプ）が貼付されたパスポート — 写真ページ、ビザページ、最新の入国スタンプのコピーを用意\n• TM30 受領書 — 証明する住所に登録されている最新のもの\n• 住所証明書類 — 以下のいずれか：署名済みの賃貸契約書、最近の電気・水道料金請求書（ご自身または家主名義、賃貸契約書と合わせて提出）、Tabian Baan（家屋登録簿）、またはコンドミニアム所有証明書（チャノーテ）\n• 証明写真2枚（4×6cm）\n• 記入済み申請書 — 入国管理局で配布\n• 政府手数料として現金500バーツ" },
          { heading: "Thailand Elite / Thailand Privilege 会員へのヒント", content: "Thailand Elite 会員は、在留証明書の取得に関してMember Contact Center（MCC）にサポートを依頼できます。MCC は正しい書類の準備を手伝い、場合によっては Chaeng Wattana での予約手配も行い、待ち時間を最小限に抑えます。\n\nElite Personal Liaison（EPL）サービスでは、Government Complex（Chaeng Wattana）の入国管理局第1部門に会員と同行し、各カウンターをご案内するとともに、提出前に書類が整っているかどうかを確認します。在留証明書を初めて取得する場合や、どの住所証明書類が受け付けられるか不明な場合に特に有用です。" }
        ],
        faqs: {
          heading: "タイの在留証明書 — よくある質問",
          items: [
            { question: "タイの在留証明書とは何ですか？", answer: "在留証明書はタイ入国管理局が発行する公式書類で、タイ国内の現登録住所を証明します。「居住証明書」または「住所確認書」とも呼ばれます。在留資格ではなく、あくまで居住地を証明するものです。銀行、陸運局、不動産登記所が外国人への手続きで必要とします。" },
            { question: "在留証明書の申請資格は？", answer: "有効な長期滞在ビザを持つ外国人であれば — Thailand Elite / Thailand Privilege 会員、退職ビザ保持者、婚姻ビザ保持者、就労許可保持者、教育ビザ保持者、LTR ビザ保持者を含む — 現在の TM30 が登録されていれば申請できます。観光ビザや無査証入国の方は原則として対象外です。" },
            { question: "バンコクで在留証明書を取得するにはどこへ行けばよいですか？", answer: "バンコクでは、Bangkok 10210 の Chaeng Wattana 道路にある Government Complex Building B の入国管理局第1部門へお越しください。バンコク以外では、地方の入国管理局事務所で申請できます。窓口は月曜日〜金曜日の 08:30〜16:30（祝日除く）に営業しています。" },
            { question: "在留証明書の費用はいくらですか？", answer: "政府手数料は500バーツで、入国管理局の窓口で現金払いです。クレジットカードやデビットカードが使えない事務所がほとんどですので、正確な金額または小額紙幣をご持参ください。" },
            { question: "在留証明書の取得にかかる時間は？", answer: "処理時間は事務所と曜日によって異なります。早めに到着すれば当日発行する入国管理局もありますが、1〜3営業日かかる場合もあります。書類提出時に担当官に確認してください。" },
            { question: "タイの在留証明書の有効期限は？", answer: "証明書は発行日から通常30日間有効です。銀行など一部の機関は発行から90日以内のものを受け付ける場合があります。提出前に受け付け期間を必ず確認してください。" },
            { question: "在留証明書と居住許可（Residence Permit）の違いは何ですか？", answer: "これらはまったく異なる書類です。在留証明書は入国管理局が発行する住所確認書類で、費用は500バーツ、数日で取得できます。居住許可（タイ永住権）は、タイへの無期限在留を許可する長期的な在留資格で、取得枠に制限があり、複数年のビザ歴が必要で、多段階の申請プロセスを経ます。Thailand Elite 会員を含むほとんどの長期滞在者が必要とするのは在留証明書のみです。" },
            { question: "在留証明書の取得に TM30 は必要ですか？", answer: "はい。入国管理局は、証明対象住所に現在の TM30 が登録されていることを確認します。未登録または期限切れの場合は、先に新しい TM30 を届け出てください（TM30 ガイドを参照）。TM30 がなければ申請は受理されません。" },
            { question: "Thailand Elite 会員は順番待ちを省略できますか？", answer: "Thailand Elite 会員は Member Contact Center（MCC）を利用して事前に書類を準備し、場合によっては予約を取ることで待ち時間を短縮できます。Elite Personal Liaison（EPL）が Chaeng Wattana 事務所への同行と手続きの案内を提供しており、お一人で訪問するよりも大幅に迅速かつ快適に手続きを進めることができます。" }
          ]
        },
        labels: {
          relatedHeading: "関連ガイド",
          bankAccountLink: "タイの銀行口座を開設する",
          drivingLink: "タイの運転免許の取得",
          tm30Link: "TM30 — 外国人住所届出",
          mccTitle: "サポートが必要ですか？Member Contact Center をご利用ください。",
          mccDesc: "Thailand Elite / Thailand Privilege 会員は、在留証明書の取得、銀行口座開設、運転免許、その他あらゆる行政手続きについて24時間サポートを受けられます。これは世界水準の Member Concierge Service（MCC）を通じて提供されます。",
          ctaTitle: "タイに居住しませんか",
          ctaDesc: "タイ唯一の長期滞在会員制居住プログラムに参加し、コンシェルジュサポート付きの5〜20年 Thailand Privilege Visa を取得しましょう。",
          ctaButton: "今すぐタイランドエリートに申請する"
        }
      },
      tdac: { shortTitle: "TDAC", title: "タイランド・デジタル入国カード（TDAC）：完全ガイド", summary: "渡航前のタイランド・デジタル入国カード（TDAC）の提出方法、提出時期、必要事項、Thailand Elite 会員向けのヒントを解説します。", sections: [
        { heading: "TDACとは？", content: "タイランド・デジタル入国カード（Thailand Digital Arrival Card、TDAC）は、タイ入国前に記入するオンライン入国フォームです。従来の紙の入国カードに代わるもので、入国管理局が旅行者と渡航情報を事前登録できるようにします。" },
        { heading: "誰が提出する必要がありますか？", content: "タイに入国するほとんどの外国人旅行者は、Thailand Elite 会員を含め、到着前に TDAC を記入する必要があります。航空会社や入国審査官に求められた場合に備え、確認情報の控えを渡航書類とともに保管してください。" },
        { heading: "TDACを記入する時期", content: "タイ行きのフライト前に TDAC を記入し、送信前にパスポート番号、到着日、便名、滞在先住所、連絡先を慎重に確認してください。" },
        { heading: "準備すべき情報", content: "パスポート、フライト情報、到着日、タイでの滞在先住所、電話またはメールの連絡先、基本的な渡航履歴情報をご準備ください。渡航書類と同じ綴りおよびパスポート番号を使用してください。" },
        { heading: "Thailand Elite 会員向けのヒント", content: "空港ファストトラックや到着アシスタンスをご利用の場合は、出発前に TDAC を記入し、到着手続きをスムーズに保ってください。確認情報はスクリーンショットと PDF で保存し、出発間際に渡航情報が変わった場合は当社チームへご連絡ください。" },
      ] },
      visaAffixation: { shortTitle: "ビザ貼付", title: "Thailand Eliteビザ貼付と新パスポート手続き", summary: "ビザ貼付の新規則：帰化申請者、必要書類、30日期限、新パスポートへの移行を含む。", sections: [
        { heading: "新規則の概要", content: "Thailand Privilege Cardは、会員申請審査およびビザ貼付手続きを更新しました。申請者を「一般申請者」と「帰化申請者」に区分します。本規則は直ちに適用され、追って通知があるまで有効です。\n\n一般申請者とは、出生時から単一国籍を持ち、帰化の形跡がない方を指します。帰化申請者とは、元の国籍に代わる、または加えて、新たな国の国籍を取得した方を指します。" },
        { heading: "一般申請者", content: "一般申請者は、引き続き標準の会員申請プロセスに従います。入国管理局での承認期間は通常4〜6週間です。\n\n一般申請者のビザ貼付に正式な期限はありませんが、後日の渡航・在留上の問題を避けるため、できるだけ早期の貼付完了を強く推奨します。" },
        { heading: "帰化申請者：追加必要書類", content: "帰化申請者は、会員申請およびビザ貼付審査において以下の追加書類が必要です：\n\n1. 原国籍のパスポート、および姓名が変更された場合は旧パスポート\n2. 該当する場合、原国籍放棄の公式書類\n3. 会員申請に使用する収入および資金源の証明書\n4. 過去6か月間のタイ国内または海外での常住証明\n\n帰化申請者の承認期間は6〜8週間が見込まれます。" },
        { heading: "帰化申請者の30日ルール", content: "帰化申請者は、会員IDの発行日から30日以内にビザ貼付を完了しなければなりません。期限を過ぎた場合、追加の身元調査が必要となり、4〜6週間さらに処理が延長されることがあります。\n\n帰化申請者の方は、ビザ貼付を遅らせず、会員承認後すぐにメンバーコンタクトセンターと調整してください。" },
        { heading: "新パスポートへのビザ貼付", content: "承認後またはビザ発行後にパスポートを更新した場合、渡航前に新パスポートへビザを移行する必要があります。事前に旧新両方のパスポートを準備し、メンバーコンタクトセンターに連絡してください。\n\n標準準備チェックリスト：\n1. 新パスポート\n2. Thailand Eliteビザステッカーが貼付された旧パスポート（お持ちの場合）\n3. パスポートのデータページのコピー\n4. 会員カードまたは承認通知\n5. 旧パスポート紛失・盗難時は警察報告書\n6. 個人情報変更時は改名・帰化関連書類\n\n旧パスポートの有無やビザ貼付済みか否かで具体的な対応が異なるため、渡航前にThailand Privilegeサポートに確認することが不可欠です。" },
        { heading: "会員向け推奨フロー", content: "1. ご自身のケースが標準か帰化かを確認する\n2. 提出前に国籍・パスポート履歴関連書類をすべて揃える\n3. 新パスポート発行時は速やかにThailand Privilegeに通知する\n4. 書類審査完了後すぐにビザ貼付予約を取る\n5. キャンセル不可の渡航予定前に貼付を完了する\n6. パスポート・添付書類・承認メールのデジタルコピーを保管する\n\n必要書類がご不明な場合、ご予約前にお問い合わせください。書類の確認をサポートいたします。" },
      ] },
    },
  },

  // Family Visa page
  nextMemberPromo: {
    badge: "期間限定オファー",
    title: "ネクストメンバー特別価格：家族1人あたり75万バーツ",
    desc: "プラチナ、ダイヤモンド、リザーブのメンバーシップに、配偶者・両親・お子様を通常のネクストメンバー料金ではなく1人75万バーツで追加できます。家族一人ひとりに専用のビザと全特典が付与されます。",
    until: "2026年12月31日まで有効",
    regular: "通常価格",
    perPerson: "1人あたり",
    cta: "家族メンバーシップの詳細",
    heroLabel: "家族メンバー（特別価格）",
  },
  family: {
    metaTitle: "タイランドエリート ファミリービザ – 家族向け長期滞在ビザ＆特典",
    metaDescription: "タイランドエリートの家族会員プランをご紹介。プラチナ、ダイヤモンド、リザーブで最大100万バーツの家族割引。",
    badge: "ファミリー会員",
    title: "ご家族のための長期滞在ビザ＆特典",
    subtitle: "タイランドエリートはプラチナ、ダイヤモンド、リザーブで家族会員オプションを提供。配偶者、両親、お子様も同じビザと特典を割引価格で利用できます。",
    intro: "ご家族でタイに移住をお考えですか？タイランドエリートなら簡単です。家族対応の会員ランクでは、各メンバーが5年間のマルチエントリービザ、空港ファストトラック、コンシェルジュ、全特典を大幅割引で取得できます。",
    promoTitle: "🔥 ファミリープロモーション — 家族1人75万バーツ（2026年12月31日まで）",
    promoDesc: "プラチナ、ダイヤモンド、リザーブのファミリープロモーション：2026年12月31日まで、家族メンバーは1人75万バーツで加入でき、それぞれがビザと全特典を取得します。",
    eligibleTitle: "家族対応の会員ランク",
    eligibleSubtitle: "3つの会員ランクが家族申請に対応。各メンバーが全特典を受けられます。",
    whoTitle: "家族メンバーとして加入できるのは？",
    whoItems: [
      "配偶者（婚姻証明書が必要）",
      "20歳未満のお子様（出生証明書が必要）",
      "主申請者の両親（出生証明書が必要）",
    ],
    docsTitle: "必要な家族書類",
    docsItems: [
      "各メンバーのパスポートコピー（有効期限1年以上）",
      "各メンバーの証明写真",
      "婚姻証明書（配偶者用）— 公式翻訳付き",
      "出生証明書（子供/両親用）— 公式翻訳付き",
      "各メンバーの申請書",
    ],
    benefitsTitle: "各家族メンバーが受けられるもの",
    benefits: [
      "個人の5年間マルチエントリー特権ビザ",
      "スワンナプーム、プーケット、チェンマイでの空港ファストトラック",
      "VIPグリーティング＆エスコートサービス",
      "専用空港ラウンジアクセス",
      "24/7メンバーコンタクトセンター",
      "90日レポート支援",
      "銀行口座開設支援",
      "ランクに応じた全ポイント＆ライフスタイル特典",
    ],
    tiers: {
      platinum: { regularPrice: "THB 1,000,000", promoPrice: "75万バーツ", saving: "1人25万バーツ節約", note: "家族メンバー1人75万バーツ（通常100万バーツ）。2026年12月31日まで。" },
      diamond: { regularPrice: "THB 1,500,000", promoPrice: "75万バーツ", saving: "1人75万バーツ節約", note: "家族メンバー1人75万バーツ（通常150万バーツ）。2026年12月31日まで。" },
      reserve: { regularPrice: "THB 2,000,000", promoPrice: "75万バーツ", saving: "1人125万バーツ節約", note: "家族メンバー1人75万バーツ（通常200万バーツ）。2026年12月31日まで。" },
    },
    faqTitle: "ファミリー会員FAQ",
    faqs: [
      { q: "承認後に家族を追加できますか？", a: "はい、会員期間中いつでも追加できます。" },
      { q: "子供にも独自のビザが必要ですか？", a: "はい、年齢に関わらず全外国人に有効なタイビザが必要です。" },
      { q: "子供が20歳になったらどうなりますか？", a: "個人会員として申請するか、家族会員として期限まで継続できます。" },
      { q: "家族割引は全ランクで利用できますか？", a: "プラチナ（10年）、ダイヤモンド（15年）、リザーブ（20年）のみです。" },
      { q: "家族申請にはどのくらいかかりますか？", a: "各メンバーが同じ承認プロセス（4-8週間）を経ます。全申請を同時に提出可能です。" },
    ],
    ctaTitle: "ご家族にタイランドエリート体験を",
    ctaButton: "ファミリー会員に申請",
    ctaNote: "個別のご相談はお気軽にお問い合わせください",
  },

  // Comparison page
  compare: {
    metaTitle: "タイランドエリート会員比較 – インタラクティブガイド＆クイズ",
    metaDescription: "タイランドエリートの全会員ランクを並べて比較。クイズであなたに最適なプログラムを見つけましょう。",
    badge: "比較ガイド",
    title: "全会員ランクを比較",
    subtitle: "インタラクティブな比較ツールとクイズで、あなたのライフスタイルに最適な会員ランクを見つけましょう。",
    startQuiz: "最適な会員を見つける",
    quizTitle: "どの会員ランクが最適ですか？",
    quizSubtitle: "4つの質問に答えるだけで、最適なランクをご提案します。",
    tableTitle: "並列比較",
    tableSubtitle: "全機能、全ランク — 一目で分かります。",
    feature: "機能",
    price: "価格",
    quiz: {
      applicantsQ: "何人で申請しますか？",
      just1: "自分だけ",
      people: "人",
      durationQ: "タイにどのくらい滞在する予定ですか？",
      budgetQ: "主申請者1人あたりの予算は？",
      prioritiesQ: "何を最も重視しますか？（複数選択可）",
      pWellness: "スパ＆ウェルネス",
      pGolf: "ゴルフ",
      pPoints: "特権ポイント",
      pFamily: "家族オプション",
      pLongterm: "長期滞在",
      next: "次へ",
      back: "戻る",
      seeResult: "おすすめを見る",
      recommendation: "おすすめ",
      noFamily: "注：このランクは家族申請に対応していません。プラチナ以上をご検討ください。",
      retake: "クイズをやり直す",
    },
    highlights: {
      family: "ファミリー対応",
      familyDesc: "プラチナ、ダイヤモンド＆リザーブは家族申請（配偶者・両親・子供）に対応：2026年12月31日まで1人75万バーツ（通常100万バーツ～）。",
      duration: "5年から20年",
      durationDesc: "長期計画に合わせた会員期間を選択。",
      value: "優れた価値",
      valueDesc: "5年65万バーツから — 最も手頃な長期滞在ビザソリューション。",
    },
  },

  // Downloads page
  downloads: {
    metaTitle: "申請書ダウンロード | タイランドエリート",
    metaDescription: "タイランドエリートの全会員パッケージの申請書とファクトシートをダウンロード。",
    title: "ダウンロードセンター",
    subtitle: "各会員パッケージの申請書をダウンロードしてください。",
    instructions: "申請するには：ダウンロード、記入、署名の上、",
    portal: "申請ポータル",
    orEmail: "またはメールで送信：",
    factSheet: "ファクトシート",
    applicationForm: "申請書",
    privilegePoints: "特権ポイント",
    privilegePointsDesc: "各会員プログラムでは、年間でさまざまなサービスに使える特権ポイントが付与されます。",
    privilegePointsSheet: "特権ポイントファクトシート",
  },
  testimonials: {
    badge: "世界中の会員に信頼されています",
    title: "会員の声",
    reviews: "Googleのクチコミ",
    sourceNote: "Googleビジネスプロフィールのレビュー · プライバシー保護のため名前を匿名化",
  },
};
